<template>
    <div style="width: 100%" >
        <div class="searchcontent headersearch"  >
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入关键字" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select size="small" v-model="searchForm.policy" placeholder="请选择申报政策" :disabled="true" style="width:300px">
                        <el-option
                        v-for="item in searchForm.policylist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item>
                    
                    
                     <el-button size="small" plain type="primary" @click="onsubmit(0,'editForm')" v-if="isonsubmit" >保存</el-button>
                      <el-button size="small" plain type="primary"  @click="onsubmit(1)"  disabled v-else>提交</el-button>
                </el-form-item>
                 <el-form-item>
                    
                     <el-button size="small" plain type="primary"  @click="onsubmit(1,'editForm')" v-if="isonsubmit">提交</el-button>
                      <el-button size="small" plain type="primary"  @click="onsubmit(1)"   disabled v-else>提交</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="searchtable unity" style="min-width:900px" >
            <el-form
                ref="editForm"
                :rules="editRules"
                label-width="80px"
                :model="editForm"
            >
            <!-- 本人信息 -->
            <div class="unitytop"   >
                <div class="unitytop_header">
                      <div class="unitytop_header_color">

                    </div>
                    <div>
                        <h3 style="color: #409EFF;">本人信息</h3>
                    </div>
                </div>
                <div class=" unitytop_list">
                    <el-form-item label="证件类型：" class="is-required" prop="p1">
                        <el-select size="small" v-model="editForm.p1" placeholder="请选择证件类型"  disabled>
                                <el-option
                                v-for="item in certificatelist"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="证件号：" class="is-required " prop="p2">
                        <el-input size="small" v-model.trim="editForm.p2" placeholder="请输入证件号" :disabled="isdisabled"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名：" class="is-required " prop="p3">
                        <el-input size="small" v-model.trim="editForm.p3" placeholder="请输入姓名" ></el-input>
                        </el-form-item>
                        <el-form-item label="性别：" class="is-required" prop="p4">
                            <el-select size="small" v-model="editForm.p4" placeholder="请选择性别" :disabled="isdisabled" >
                                <el-option
                                v-for="item in sexlist"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="出生日期：" class="is-required" prop="p5" >
                                <el-date-picker
                                size="small"
                                format="yyyy-MM-dd"
                                v-model="editForm.p5"
                                type="date"
                                placeholder="请选择出生日期"
                                value-format="timestamp"
                                :disabled="isdisabled"
                                 :picker-options="pickerOptions"
                                ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="户口性质：" class="is-required" prop="p6">
                            <el-select size="small" v-model="editForm.p6" placeholder="请选择户口性质"  >
                                <el-option
                                v-for="item in registeredlist"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="婚姻状况：" class="is-required" prop="p7">
                            <el-select size="small" v-model="editForm.p7" placeholder="请选择婚姻状况" @change="changemaritalstatus" >
                                <el-option
                                v-for="item in maritalstatuslist"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="婚姻变动日期：" class="is-required" prop="p8">
                                <el-date-picker
                                size="small"
                                format="yyyy-MM-dd"
                                v-model="editForm.p8"
                                type="date"
                                placeholder="请选择婚姻变动日期"
                                value-format="timestamp"
                                 :picker-options="pickerOptions"
                                ></el-date-picker>
                        </el-form-item>
                        <!-- class="is-required " prop="p11" -->
                        <el-form-item label="工作单位：" >
                          <el-input size="small" v-model.trim="editForm.p11" placeholder="请输入工作单位" ></el-input>
                        </el-form-item>
                        <el-form-item label="享受地户籍：" class="is-required  regionlist" >
                            <div class="regionlist-item">
                                <el-form-item  class="is-required  regionlist"  prop="province01" >
                                    <el-select size="small" v-model="editForm.province01" placeholder="请选择省"  @change="cityFormchange(1,2,editForm.province01)" disabled>
                                        <el-option
                                        v-for="item in provincelist01"
                                         :key="item.baseRegionID"
                                        :label="item.baseRegionName"
                                        :value="item.baseRegionID">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="regionlist-item">
                                <el-form-item  class="is-required  regionlist"  prop="city01" >
                                    <el-select size="small" v-model="editForm.city01" placeholder="请选择市" @change="cityFormchange(1,3,editForm.city01)" >
                                        <el-option
                                        v-for="item in citylist01"
                                        :key="item.baseRegionID"
                                        :label="item.baseRegionName"
                                        :value="item.baseRegionID">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="regionlist-item">
                                  <el-form-item  class="is-required  regionlist"  prop="county01" >
                                    <el-select size="small" v-model="editForm.county01" placeholder="请选择区/县"  @change="cityFormchange(1,4,editForm.county01)" >
                                        <el-option
                                        v-for="item in countylist01"
                                       :key="item.baseRegionID"
                                        :label="item.baseRegionName"
                                        :value="item.baseRegionID">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="regionlist-item">
                                <el-form-item  class="is-required  regionlist"  prop="town01" >
                                    <el-select size="small" v-model="editForm.town01" placeholder="请选择街道/乡/镇"  @change="cityFormchange(1,5,editForm.town01)" >
                                        <el-option
                                        v-for="item in townlist01"
                                        :key="item.baseRegionID"
                                        :label="item.baseRegionName"
                                        :value="item.baseRegionID">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="regionlist-item">
                                <el-form-item  class="is-required  regionlist"  prop="village01" >
                                    <el-select size="small" v-model="editForm.village01" placeholder="请选择社区/村"  @change="comparisonchange(editForm.village01)">
                                        <el-option
                                        v-for="item in villagelist01"
                                        :key="item.baseRegionID"
                                        :label="item.baseRegionName"
                                        :value="item.baseRegionID">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form-item>
                        <!-- class="is-required " prop="p10" -->
                        <el-form-item label="原户籍地址详情：" >
                        <el-input size="small" v-model.trim="editForm.p10" placeholder="请输入原户籍地址详情" ></el-input>
                        </el-form-item>
                        <el-form-item label="现居住地址：" class="is-required  regionlist" >
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist"  prop="province03" >
                                        <el-select size="small" v-model="editForm.province03" placeholder="请选择省" @change="cityFormchange(3,2,editForm.province03)" >
                                            <el-option
                                            v-for="item in provincelist03"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist"  prop="city03" >
                                        <el-select size="small" v-model="editForm.city03" placeholder="请选择市"  @change="cityFormchange(3,3,editForm.city03)">
                                            <el-option
                                            v-for="item in citylist03"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                        <el-form-item  class="is-required  regionlist"  prop="county03" >
                                        <el-select size="small" v-model="editForm.county03" placeholder="请选择区/县"  @change="cityFormchange(3,4,editForm.county03)">
                                            <el-option
                                            v-for="item in countylist03"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist"  prop="town03" >
                                        <el-select size="small" v-model="editForm.town03" placeholder="请选择街道/乡/镇"  @change="cityFormchange(3,5,editForm.town03)">
                                            <el-option
                                            v-for="item in townlist03"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist"  prop="village03" >
                                        <el-select size="small" v-model="editForm.village03" placeholder="请选择社区/村"  >
                                            <el-option
                                            v-for="item in villagelist03"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                        </el-form-item>
                        <!-- class="is-required " prop="tp4" -->
                        <el-form-item label="现居住地址详情：" >
                            <el-input size="small" v-model.trim="editForm.tp4" placeholder="请输入现居住地址详情" ></el-input>
                        </el-form-item>
                </div>
            </div>
            <!-- 配偶信息 -->
            <div class="unitytop" v-if="editForm.p7==1 || editForm.p7==2">
                <div class="unitytop_header">
                      <div class="unitytop_header_color">

                    </div>
                    <div>
                        <h3 style="color: #409EFF;">配偶信息</h3>
                    </div>
                </div>
                <div class=" unitytop_list">
                     <el-form-item label="证件类型：" class="is-required" prop="op1" > 
                        <el-select size="small" v-model.trim="editForm.op1" placeholder="请选择证件类型"  disabled>
                            <el-option
                            v-for="item in certificatelist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item label="证件号：" class="is-required " prop="op2">
                       <el-input size="small" v-model.trim="editForm.op2" placeholder="请输入证件号" ></el-input>
                    </el-form-item>
                    <el-form-item label="姓名：" class="is-required " prop="op3">
                       <el-input size="small" v-model.trim="editForm.op3" placeholder="请输入姓名" ></el-input>
                    </el-form-item>
                    <el-form-item label="性别：" class="is-required" prop="op4">
                        <el-select size="small" v-model="editForm.op4" placeholder="请选择性别"  >
                            <el-option
                            v-for="item in sexlist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item  label="出生日期：" class="is-required" prop="op5">
                            <el-date-picker
                            size="small"
                            format="yyyy-MM-dd"
                            v-model="editForm.op5"
                            type="date"
                            placeholder="请选择出生日期"
                            value-format="timestamp"
                             :picker-options="pickerOptions"
                            ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="户口性质：" class="is-required" prop="op6">
                        <el-select size="small" v-model.trim="editForm.op6" placeholder="请选择户口性质"  >
                            <el-option
                            v-for="item in registeredlist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="婚姻状况：" class="is-required" prop="op7">
                        <el-select size="small" v-model="editForm.op7" placeholder="请选择婚姻状况"  >
                            <el-option
                            v-for="item in maritalstatuslist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="婚姻变动日期：" class="is-required" prop="op8">
                            <el-date-picker
                            size="small"
                            format="yyyy-MM-dd"
                            v-model="editForm.op8"
                            type="date"
                            placeholder="请选择婚姻变动日期"
                            value-format="timestamp"
                             :picker-options="pickerOptions"
                            ></el-date-picker>
                    </el-form-item>
                    <el-form-item >
                    </el-form-item>
                    <el-form-item label="户籍地址：" class="is-required  regionlist" >
                        <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="province02" >
                                <el-select size="small" v-model="editForm.province02" placeholder="请选择省"  @change="cityFormchange(2,2,editForm.province02)">
                                    <el-option
                                    v-for="item in provincelist02"
                                    :key="item.baseRegionID"
                                        :label="item.baseRegionName"
                                        :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="city02" >
                                <el-select size="small" v-model="editForm.city02" placeholder="请选择市"  @change="cityFormchange(2,3,editForm.city02)">
                                    <el-option
                                    v-for="item in citylist02"
                                   :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                                <el-form-item  class="is-required  regionlist"  prop="county02" >
                                <el-select size="small" v-model="editForm.county02" placeholder="请选择区/县"  @change="cityFormchange(2,4,editForm.county02)">
                                    <el-option
                                    v-for="item in countylist02"
                                    :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="town02" >
                                <el-select size="small" v-model="editForm.town02" placeholder="请选择街道/乡/镇"  @change="cityFormchange(2,5,editForm.town02)">
                                    <el-option
                                    v-for="item in townlist02"
                                       :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="regionlist-item">
                            <el-form-item  class="is-required  regionlist"  prop="village02" >
                                <el-select size="small" v-model="editForm.village02" placeholder="请选择社区/村"  >
                                    <el-option
                                    v-for="item in villagelist02"
                                       :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form-item>
                    <!-- class="is-required " prop="op10" -->
                    <el-form-item label="原户籍地址详情：" >
                       <el-input size="small" v-model.trim="editForm.op10" placeholder="请输入原户籍地址详情" ></el-input>
                    </el-form-item>
                </div>
            </div>
            <!-- 子女信息 -->
             <div class="unitytop">
                <div class="unitytop_header">
                      <div class="unitytop_header_color">

                    </div>
                    <div>
                        <h3 style="color: #409EFF;">子女基本信息</h3>
                    </div>
                </div>
                <div class=" unitytop_list">
                    
                   <div v-for="(item,k) in editForm.childrenlist" :key="k" class="childrenlist">
                       <div class="childrenlist-left">  
                           <div class="childrenlist-top">
                                <el-form-item label="姓名：" class="is-required " :prop="'childrenlist.'+k+'.zp1'" 
                                    :rules="[
                                    {
                                        required: true, message: '请输入姓名', trigger: 'change'
                                        
                                    }]">
                            <el-input size="small" v-model.trim="item.zp1" placeholder="请输入姓名" ></el-input>
                            </el-form-item>
                            <el-form-item label="性别：" class="is-required" :prop="'childrenlist.'+k+'.zp2'" 
                                :rules="{
                                    required: true, message: '请选择性别', trigger: 'change'
                                }">
                                <el-select size="small" v-model="item.zp2" placeholder="请选择性别"  @change="changesex(k,item.zp2)" >
                                    <el-option
                                    v-for="item in sexlist"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="出生日期：" class="is-required" :prop="'childrenlist.'+k+'.zp3'"
                            :rules="{
                                    type: 'date',required: true, message: '请选择出生日期', trigger: 'change'
                                }">
                                    <el-date-picker
                                    size="small"
                                    format="yyyy-MM-dd"
                                    v-model="item.zp3"
                                    type="date"
                                    placeholder="请选择出生日期"
                                    value-format="timestamp"
                                     :picker-options="pickerOptions"
                                    ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="身份证号：" class="is-required " :prop="'childrenlist.'+k+'.zp4'" >
                              <el-input size="small" v-model.trim="item.zp4" placeholder="请输入身份证号" ></el-input>
                            </el-form-item>
                            <el-form-item  label="与父亲的关系：" class="is-required" :prop="'childrenlist.'+k+'.zp5'"
                              :rules="{
                                    required: true, message: '请选择与父亲的关系', trigger: 'change'
                                }">
                                <el-select size="small" v-model="item.zp5" placeholder="请选择与父亲的关系" @change="changefatherlist"  >
                                    <el-option
                                    v-for="item in fatherlist"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="与母亲的关系：" class="is-required" :prop="'childrenlist.'+k+'.zp6'" 
                            :rules="{
                                    required: true, message: '请选择与母亲的关系', trigger: 'change'
                                }">
                                <el-select size="small" v-model="item.zp6" placeholder="请选择与母亲的关系" @change="changefatherlist" >
                                    <el-option
                                    v-for="item in fatherlist"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                             <el-form-item label="户籍地址：" class="is-required  regionlist" >
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist"  :prop="'childrenlist.'+k+'.province'"
                                        :rules="{
                                            required: true, message: '请选择省', trigger: 'change'
                                        }" >
                                        <el-select size="small" v-model="item.province" placeholder="请选择省" :disabled="item.isprovincedisabled"   @change="childrenchange(2,item.province,k)">
                                            <el-option
                                                v-for="item in item.provincelist"
                                                :key="item.baseRegionID"
                                                :label="item.baseRegionName"
                                                :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist" :prop="'childrenlist.'+k+'.city'"
                                        :rules="{
                                            required: true, message: '请选择市', trigger: 'change'
                                        }"  >
                                        <el-select size="small" v-model="item.city" placeholder="请选择市" :disabled="item.isprovincedisabled" @change="childrenchange(3,item.city,k)" >
                                            <el-option
                                            v-for="item in item.citylist"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist"  :prop="'childrenlist.'+k+'.county'"
                                       :rules="{
                                            required: true, message: '请选择区/县', trigger: 'change'
                                        }"  >
                                        <el-select size="small" v-model="item.county" placeholder="请选择区/县" :disabled="item.isprovincedisabled"  @change="childrenchange(4,item.county,k)" >
                                            <el-option
                                            v-for="item in item.countylist"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist" :prop="'childrenlist.'+k+'.town'"
                                       :rules="{
                                            required: true, message: '请选择街道/乡/镇', trigger: 'change'
                                        }"  >
                                        <el-select size="small" v-model="item.town" placeholder="请选择街道/乡/镇" :disabled="item.isprovincedisabled"  @change="childrenchange(5,item.town,k)" >
                                            <el-option
                                            v-for="item in item.townlist"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="regionlist-item">
                                    <el-form-item  class="is-required  regionlist"  :prop="'childrenlist.'+k+'.village'"
                                       :rules="{
                                            required: true, message: '请选择社区/村', trigger: 'change'
                                        }"  >
                                        <el-select size="small" v-model="item.village" placeholder="请选择社区/村"  @change="childrencomparisonchange(item.village,k)">
                                            <el-option
                                            v-for="item in item.villagelist"
                                            :key="item.baseRegionID"
                                            :label="item.baseRegionName"
                                            :value="item.baseRegionID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <!--  -->
                            <div v-if="searchForm.policy==2 ||searchForm.policy==1 " class="localitylist">
                                 <el-form-item label="是否本地：" class="is-required " >
                                    <el-select size="small" v-model="item.locality" placeholder="请选择是否是本地"  :disabled="iscitydisabled" >
                                        <el-option
                                        v-for="item in localitylist"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                   
                                </el-form-item>
                                <el-form-item class="islocality">
                                </el-form-item>
                            </div>
                           
                            <el-form-item  label="身体状况：" class="is-required" :prop="'childrenlist.'+k+'.zp7'"
                            :rules="{
                                    required: true, message: '请选择身体状况', trigger: 'change'
                                }">
                                <el-select size="small" v-model="item.zp7" placeholder="请选择身体状况"  @change="changesurvival(k,item.zp2)">
                                    <el-option
                                    v-for="item in physicallist"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="残疾账号：" class="is-required " :prop="'childrenlist.'+k+'.zp8'" v-if="item.zp7==2"
                                :rules="{
                                    required: true, message: '请输入残疾账号', trigger: 'blur'
                                }">
                            <el-input size="small" v-model.trim="item.zp8" placeholder="请输入残疾账号" ></el-input>
                            </el-form-item>
                            <el-form-item  label="残疾类型：" class="is-required" v-if="item.zp7==2" :prop="'childrenlist.'+k+'.zp9'"
                                :rules="{
                                    required: true, message: '请选择残疾类型', trigger: 'change'
                                }">
                                <el-select size="small" v-model="item.zp9" placeholder="请选择残疾类型"  >
                                    <el-option
                                    v-for="item in disabilitytypeslist"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="残疾等级：" class="is-required" v-if="item.zp7==2" :prop="'childrenlist.'+k+'.zp10'"
                                :rules="{
                                    required: true, message: '请选择残疾等级', trigger: 'change'
                                }">
                                <el-select size="small" v-model="item.zp10" placeholder="请选择残疾等级"  >
                                    <el-option
                                    v-for="item in disabilitygradelist"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="残疾日期：" class="is-required" v-if="item.zp7==2" :prop="'childrenlist.'+k+'.zp11'"
                                :rules="{
                                    required: true, message: '请选择残疾日期', trigger: 'change'
                                }">
                                    <el-date-picker
                                    size="small"
                                    format="yyyy-MM-dd"
                                    v-model="item.zp11"
                                    type="date"
                                    placeholder="请选择残疾日期"
                                    value-format="timestamp"
                                     :picker-options="pickerOptions"
                                    ></el-date-picker>
                            </el-form-item>
                            
                            <el-form-item label="死亡单位：" class="is-required "  :prop="'childrenlist.'+k+'.zp12'" v-if="item.zp7==4"
                            :rules="{
                                    required: true, message: '请输入死亡单位', trigger: 'blur'
                                }">
                            <el-input size="small" v-model.trim="item.zp12" placeholder="请输入死亡单位" ></el-input > 
                            </el-form-item>
                        
                            <el-form-item  label="死亡日期：" class="is-required" v-if="item.zp7==4" :prop="'childrenlist.'+k+'.zp13'"
                            :rules="{
                                    required: true, message: '请选择死亡日期', trigger: 'change'
                                }">
                                    <el-date-picker
                                    size="small"
                                    format="yyyy-MM-dd"
                                    v-model="item.zp13"
                                    type="date"
                                    placeholder="请选择死亡日期"
                                    value-format="timestamp"
                                     :picker-options="pickerOptions"
                                    ></el-date-picker>
                            </el-form-item>
                           </div>
                        
                            <div class="childrenlist-buttom" v-if="item.zp5==2 || item.zp5==4 || item.zp6==2 || item.zp6==4">
                                <!-- <el-form-item  label="是否收养：" class="is-required" :prop="'childrenlist.'+k+'.zp14'"
                                    :rules="{
                                        required: true, message: '请选择是否收养 ', trigger: 'change'
                                    }">
                                    <el-select size="small" v-model="item.zp14" placeholder="请选择是否收养" @change="changeWhethertoadoptl()" >
                                        <el-option
                                        v-for="item in adoptionlist"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item> -->
                                <el-form-item label="是否收养：" class="is-required "  :prop="'childrenlist.'+k+'.zp12'">
                                  <el-input size="small" v-model="item.zp14"  placeholder="是" disabled ></el-input > 
                                </el-form-item>
                                <el-form-item  label="收养日期：" class="is-required" :prop="'childrenlist.'+k+'.zp15'"
                                    :rules="{
                                        type: 'date',required: true, message: '请选择收养日期', trigger: 'change'
                                    }">
                                        <el-date-picker
                                        size="small"
                                        format="yyyy-MM-dd" 
                                        v-model="item.zp15"
                                        type="date"
                                        placeholder="请选择收养日期"
                                        value-format="timestamp"
                                         :picker-options="pickerOptions"
                                        ></el-date-picker>
                                </el-form-item>
                                <el-form-item  label="被收养身份：" class="is-required" :prop="'childrenlist.'+k+'.zp16'"
                                    :rules="{
                                        required: true, message: '请选择被收养身份 ', trigger: 'change'
                                    }">
                                    <el-select size="small" v-model="item.zp16" placeholder="被收养身份"  >
                                        <el-option
                                        v-for="item in adoptedstatuslist"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            
                        
                       </div>
                       <div class="childrenlist-right">
                            <div  v-if="editForm.childrenlist.length>=2">
                                <el-button type="primary" icon="el-icon-minus" circle @click="redlabel(k)"></el-button>
                            </div >
                            <div style="margin-left:40px;">
                                <el-button type="primary" icon="el-icon-plus" circle @click="addlabel(k)"></el-button>
                            </div >
                       </div>
                      
                   </div>
                   <div class="childrennum">
                        <el-form-item label="曾生育子女及收养子女数：" class="is-required"> 
                            <span>{{editForm.plansum}}</span>
                        </el-form-item>
                        <el-form-item label="男孩数：" class="is-required">
                            <span>{{editForm.planboy}}</span>
                        </el-form-item>
                        <el-form-item label="女孩数：" class="is-required">
                            <span>{{editForm.plangirl}}</span>
                        </el-form-item>
                        <el-form-item label="现有存活子女数：" class="is-required">
                            <span>{{editForm.survivesum}}</span>
                        </el-form-item>
                        <el-form-item label="男孩数：" class="is-required">
                            <span>{{editForm.surviveboy}}</span>
                        </el-form-item>
                        <el-form-item label="女孩数：" class="is-required">
                            <span>{{editForm.survivegirl}}</span>
                        </el-form-item>
                   </div>
                </div>
            </div>
            <!-- 其他信息 -->
             <div class="unitytop">
                <div class="unitytop_header">
                      <div class="unitytop_header_color">

                    </div>
                    <div>
                        <h3 style="color: #409EFF;">其他信息</h3>
                    </div>
                </div>
                <div class=" unitytop_list">
                   <!-- <el-form-item label="银行账号：" class="is-required " prop="tp1">
                     <el-input size="small" v-model.trim="editForm.tp1" placeholder="请输入银行账号" ></el-input>
                    </el-form-item> -->
                    <el-form-item label="联系电话：" class="is-required " prop="tp2">
                        <el-input size="small" v-model.trim="editForm.tp2" placeholder="请输入联系电话" ></el-input>
                    </el-form-item>

                     <el-form-item label="养老保险类型："  v-if="searchForm.policy==3">
                            <el-select size="small" v-model.trim="editForm.tp5" placeholder="请选择养老保险类型"  >
                                <el-option
                                    v-for="item in providelist"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                    </el-form-item>
                    <el-form-item label="退休证号："  v-if="searchForm.policy==3">
                        <el-input size="small" v-model.trim="editForm.tp6" placeholder="请输入退休账号" oninput ="value=value.replace(/[^\a-\z\A-\Z0-9]/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="退休金单位：" v-if="searchForm.policy==3">
                        <el-input size="small" v-model.trim="editForm.tp7" placeholder="请输入退休金单位" ></el-input>
                    </el-form-item>
                     <el-form-item  label="退休日期："  v-if="searchForm.policy==3">
                            <el-date-picker
                            size="small"
                            format="yyyy-MM-dd"
                            v-model="editForm.tp8"
                            type="date"
                            placeholder="请选择退休日期"
                            value-format="timestamp"
                             :picker-options="pickerOptions"
                            ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="退休金发放地：" class=" regionlist" v-if="searchForm.policy==3">
                        <div class="regionlist-item">
                            <el-select size="small" v-model="editForm.province04" placeholder="请选择省"  @change="cityFormchange(4,2,editForm.province04)">
                                <el-option
                                v-for="item in provincelist04"
                                   :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="regionlist-item">
                            <el-select size="small" v-model="editForm.city04" placeholder="请选择市"  @change="cityFormchange(4,3,editForm.city04)" >
                                <el-option
                                v-for="item in citylist04"
                              :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="regionlist-item">
                            <el-select size="small" v-model="editForm.county04" placeholder="请选择区/县"   @change="cityFormchange(4,4,editForm.county04)">
                                <el-option
                                v-for="item in countylist04"
                                   :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="regionlist-item">
                            <el-select size="small" v-model="editForm.town04" placeholder="请选择街道/乡/镇"   @change="cityFormchange(4,5,editForm.town04)">
                                <el-option
                                 v-for="item in townlist04"
                                 :key="item.baseRegionID"
                                :label="item.baseRegionName"
                                :value="item.baseRegionID">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="regionlist-item">
                            <el-select size="small" v-model="editForm.village04" placeholder="请选择社区/村"  >
                                <el-option
                                v-for="item in villagelist04"
                                  :key="item.baseRegionID"
                                    :label="item.baseRegionName"
                                    :value="item.baseRegionID">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    
                    <el-form-item  label="户口迁入本省日期："  v-if="searchForm.policy==3">
                            <el-date-picker
                            size="small"
                            format="yyyy-MM-dd"
                            v-model="editForm.tp9"
                            type="date"
                            placeholder="请选择户口迁入本省日期"
                            value-format="timestamp"
                             :picker-options="pickerOptions"
                            ></el-date-picker>
                    </el-form-item>
                     <el-form-item  label="户口迁出本省日期："  v-if="searchForm.policy==3">
                            <el-date-picker
                            size="small"
                            format="yyyy-MM-dd"
                            v-model="editForm.tp10"
                            type="date"
                            placeholder="请选择户口迁出本省日期"
                            value-format="timestamp"
                             :picker-options="pickerOptions"
                            ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="户口迁出地："  v-if="searchForm.policy==3">
                      <el-input size="small" v-model.trim="editForm.tp11" placeholder="请输入户口迁出地" ></el-input>
                    </el-form-item>
                </div>
            </div>
            <!-- 资料上传 -->
             <div class="unitytop">
                <div class="unitytop_header">
                      <div class="unitytop_header_color">

                    </div>
                    <div>
              <h3 style="color: #409eff">资料上传 <span style="color:#FC7276;font-size:14px;font-weight: normal;"><i class="el-icon-warning-outline"></i>只能上传JPG、JPEG、PNG格式的图片，且图片不大于4M</span></h3>
                    </div>
                </div>
                <div class=" unityimg_list">
                   <el-form-item  label="本人身份证信息：" class="is-required unityimg_list_item unityimglistitem">
                       <div >
                            <uploadimg
                            :class="{disUoloadSty:editForm.p31img}"
                            :imgLimit="imgLimitlist1"
                            :sourceType="imgsourceType1"
                            :productImgList="editForm.imgp31"
                            @UploadImgSuccess="uploadAddImglist1"
                            @DelImgSuccess="DelImglist1" 
                            ></uploadimg>
                            <div class="uploadImgtext">
                                身份证正面
                            </div>
                        </div>
                        <div >
                            <uploadimg
                            :class="{disUoloadSty:editForm.p32img}"
                            :imgLimit="imgLimitlist2"
                            :sourceType="imgsourceType2"
                            :productImgList="editForm.imgp32"
                            @UploadImgSuccess="uploadAddImglist2"
                            @DelImgSuccess="DelImglist2" 
                            ></uploadimg>
                            <div class="uploadImgtext">
                                身份证反面
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item  label="本人户口信息：" class="is-required unityimg_list_item unityimglistitem" style="margin-left:100px"> 
                       <div > 
                            <uploadimg
                            :class="{disUoloadSty:editForm.p33img}"
                            :imgLimit="imgLimitlist3"
                            :sourceType="imgsourceType3"
                            :productImgList="editForm.imgp33"
                            @UploadImgSuccess="uploadAddImglist3"
                            @DelImgSuccess="DelImglist3" 
                            ></uploadimg>
                            <div class="uploadImgtext">
                                首页
                            </div>
                        </div>
                        <div >
                            <uploadimg
                            :class="{disUoloadSty:editForm.p34img}"
                            :imgLimit="imgLimitlist4"
                            :sourceType="imgsourceType4"
                            :productImgList="editForm.imgp34"
                            @UploadImgSuccess="uploadAddImglist4"
                            @DelImgSuccess="DelImglist4" 
                            ></uploadimg>
                            <div class="uploadImgtext">
                                本人页
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item  label="配偶户口信息：" class="is-required unityimg_list_item unityimglistitem"  v-if="editForm.p7==1 || editForm.p7==2"  > 
                       <div >
                            <uploadimg
                            :class="{disUoloadSty:editForm.p35img}"
                            :imgLimit="imgLimitlist5"
                            :sourceType="imgsourceType5"
                            :productImgList="editForm.imgp35"
                            @UploadImgSuccess="uploadAddImglist5"
                            @DelImgSuccess="DelImglist5" 
                            ></uploadimg>
                            <div class="uploadImgtext">
                                首页
                            </div>
                        </div>
                        <div  >
                            <uploadimg
                            class="uploadImg2"
                           :class="{disUoloadSty:editForm.p36img}"
                            :sourceType="imgsourceType6"
                            :productImgList="editForm.imgp36"
                            @UploadImgSuccess="uploadAddImglist6"
                            @DelImgSuccess="DelImglist6" 
                            ></uploadimg>
                            <div class="uploadImgtext">
                                本人页
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item  label="婚姻证明信息：" class="is-required" style="margin-left:100px">
                     <!-- <el-form-item  label="婚姻证明信息：" class="is-required" v-if="editForm.p7==1 || editForm.p7==2" style="margin-left:100px"> -->
                       <div>
                            <uploadimg
                            class="uploadImg9"
                             :class="{disUoloadSty:editForm.p39img}"
                            :imgLimit="imgLimitlist9"
                            :sourceType="imgsourceType9"
                            :productImgList="editForm.imgp39"
                            @UploadImgSuccess="uploadAddImglist9"
                            @DelImgSuccess="DelImglist9" 
                            ></uploadimg>
                        </div>
                    </el-form-item>
                    <el-form-item  label="独生子女光荣证："  class="unityimglistitem" v-if="searchForm.policy==2">
                       <div>
                            <uploadimg
                            :class="{disUoloadSty:editForm.p37img}"
                            :imgLimit="imgLimitlist7"
                            :sourceType="imgsourceType7"
                            :productImgList="editForm.imgp37"
                            @UploadImgSuccess="uploadAddImglist7"
                            @DelImgSuccess="DelImglist7" 
                            ></uploadimg>
                           
                        </div>
                    </el-form-item>
                     <el-form-item  label="收养证：" class="unityimglistitem is-required" style="width: 100% !important" v-if="isWhethertoadopt==true">
                       <div>
                           <!-- :class="{disUoloadSty:editForm.p40img}" -->
                            <uploadimg
                            :imgLimit="imgLimitlist10"
                            :sourceType="imgsourceType10"
                            :productImgList="editForm.imgp40"
                            @UploadImgSuccess="uploadAddImglist10"
                            @DelImgSuccess="DelImglist10" 
                            ></uploadimg>
                           
                        </div>
                    </el-form-item>
                    
                    <el-form-item  label="残疾证明信息：" class="is-required" style="width: 100% !important" v-if="isdisability==true">
                       <div>
                            <uploadimg
                            class="uploadImg1"
                            :imgLimit="imgLimitlist8"
                            :sourceType="imgsourceType8"
                            :productImgList="editForm.imgp38"
                            @UploadImgSuccess="uploadAddImglist8"
                            @DelImgSuccess="DelImglist8" 
                            ></uploadimg>
                           
                        </div>
                    </el-form-item>
                   
                </div>
            </div>
            </el-form>
        </div>
        
    </div>
</template>
<script>
import { systemcodeModule } from "@/request/systemmange.js";
import { policydeclarationinfoModule } from "@/request/windowtoaccept.js";
import $ from 'jquery'
import store from '@/store'
import { publicFun } from "@/tools/time.js";
import uploadimg from "@/components/uploadImg/uploadImg.vue";
import { regionModule } from "@/request/systemmange.js";
import {baseconfig} from '@/config.js'
import {isIdentityId} from '@/tools/isIdentityId.js'
export default {
    props: ["RecordID","index","markID","filterShow"],
    name: "Windowtoacceptredact",
    components: {
        uploadimg,
    },
    data(){
        var validatecard  = (rule, code, callback) => {
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            var tip = ""
            var pass = true
            if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
                tip = "身份证号格式错误"
                pass = false;
            } else if (!city[code.substr(0, 2)]) {
                // tip = "地址编码错误"
                tip="身份证输入错误"
                pass = false
            } else {
                // 18位身份证需要验证最后一位校验位
                if (code.length === 18) {
                code = code.split('')
                // ∑(ai×Wi)(mod 11)
                // 加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                // 校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
                var sum = 0
                var ai = 0
                var wi = 0
                for (var i = 0; i < 17; i++) {
                    ai = code[i]
                    wi = factor[i]
                    sum += ai * wi
                }
                var last = parity[sum % 11];
                if (parity[sum % 11] != code[17]) {
                    // tip = "校验位错误"
                    tip="身份证输入错误"
                    pass = false
                }
                }
            }
            if (!pass) {
                callback(new Error(tip))
            } else {
                callback()
            }
        }
        var validatecards =(rule,value,callback)=>{
            if (value != '') {
                callback()
            }
        }
        var validatetel =(rule,value,callback)=>{
            if (value != '') {
            
                // var regex = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,16}$/
                var regex = /^1[3456789]\d{9}$/
                if(regex.test(value)){
                    callback()
                }else{
                    callback(new Error('请输入正确的联系电话'))
                }
            }
        }
        return {
              pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            
            isonsubmit:false,
            flag: false,
            policyMeasureID:0,
            applyhouseid:0,
            applyRecordID:0,
            // 展示残疾的图片
            isdisability:false,
            // 是否展示收养证图片
            isWhethertoadopt:false,
            // 是否可编辑
            isCanSubmit:1,
            isdisabled:false,
            // 申请记录id
            ApplicationRecordID:0,
            ApplicationRecordID02:0,
            // 半边户
            translucence:0,

            regioninfogetlist:0,
            // 地区
            adrss01:'',
            adrss02:'',
            adrss03:'',
            adrss04:'',
            provincelist01:[],
            citylist01:[],
            countylist01:[],
            townlist01:[],
            villagelist01:[],
            provincelist02:[],
            citylist02:[],
            countylist02:[],
            townlist02:[],
            villagelist02:[],
            provincelist03:[],
            citylist03:[],
            countylist03:[],
            townlist03:[],
            villagelist03:[],
            provincelist04:[],
            citylist04:[],
            countylist04:[],
            townlist04:[],
            villagelist04:[],
           

            //资料上传
            imgLimitlist1:1,
            imgsourceType1:1,
            imgLimitlist2:1,
            imgsourceType2:1,
            imgLimitlist3:1,
            imgsourceType3:1,
            imgLimitlist4:1,
            imgsourceType4:1,
            imgLimitlist5:1,
            imgsourceType5:1,
            imgLimitlist6:1,
            imgsourceType6:1,
            imgLimitlist7:1,
            imgsourceType7:1,
            imgLimitlist8:9,
            imgsourceType8:2,
            imgLimitlist9:1,
            imgsourceType9:1,
            imgLimitlist10:9,
            imgsourceType10:1,

            // 表数据
            certificatelist:[],
            sexlist:[
                { value: 1, label: "男" },
                { value: 2, label: "女" },
            ],
             //户口性质
            registeredlist:[
                {
                    value:1,
                    label:'农业'
                },
                {
                    value:2,
                    label:'非农业',
                },
            ],
             // 婚姻状况
            maritalstatuslist:[
                 {
                    value:1,
                    label:'初婚'
                },
                {
                    value:2,
                    label:'再婚',
                },
                 {
                    value:3,
                    label:'离婚',
                },
                {
                    value:4,
                    label:'丧偶',
                },
            ],
             // 养老保险类型
            providelist:[],
            searchForm:{
                keywords:'申报',
                policy:'',
                policylist:[],
                certificate:1,
                certificatelist:[],
                identitynum:''
            },
            editForm:{
                p1:1,
                p2:'',
                p3:'',
                p4:'',
                p5:'',
                p6:'',
                p7:'',
                p8:'',
                p9:'',
                p10:'',
                p11:'',
                // 配偶
                op1:1,
                op2:'' ,
                op3:'',
                op4:'',
                op5:'',
                op6:'',
                op7:'',
                op8:'',
                op9:'',
                op10:'',
                

                tp1:'',
                tp2:'',
                tp3:'',
                tp4:'',
                tp5:'',
                tp6:'',
                tp7:'',
                tp8:'' ,
                tp9:'' ,
                tp10:'' ,
                tp11:'' ,
                 // 个人信息
                province01:'',
                city01:'',
                county01:'',
                town01:'',
                village01:'',
                // 配偶信息
                province02:'',
                city02:'',
                county02:'',
                town02:'',
                village02:'',
                // 其他信息
                // 现居住地
                province03:'',
                city03:'',
                county03:'',
                town03:'',
                village03:'',
                // 退休金发放地
                province04:'',
                city04:'',
                county04:'',
                town04:'',
                village04:'',

                p31:'',
                p31img:false,
                imgp31:[],
                p32:'',
                p32img:false,
                imgp32:[],
                p33:'',
                p33img:false,
                imgp33:[],
                p34:'',
                p34img:false,
                imgp34:[],
                p35:'',
                p35img:false,
                imgp35:[],
                p36:'',
                imgp36:[],
                p36img:false,
                p37:'',
                imgp37:[],
                p37img:false,
                p38:'',
                imgp38:[],
                p39:'',
                imgp39:[],
                p39img:false,
                p40:'',
                imgp40:[],
                p40img:false,

                // 子女
               childrenlist:[
                   {
                       ApplicationRecordID03:0,
                       zp1:'',
                       zp2:'',
                       zp3:'',
                       zp4:'',
                       zp5:'',
                       zp6:'',
                       zp7:'',
                       zp8:'',
                       zp9:'',
                       zp10:'',
                       zp11:'',
                       zp12:'',
                       zp13:'',
                       zp14:'是',
                       zp15:'',
                       zp16:'',
                       provincelist:[],
                        citylist:[],
                        countylist:[],
                        townlist:[],
                        villagelist:[],
                        province:'',
                        city:'',
                        county:'',
                        town:'',
                        village:'',
                        isprovincedisabled:false,
                   },
                   
               ],
               //计划生育及收养子女数： 
                plansum:1,
                planboy:0,
                plangirl:0,
                // 现有存活
                survivesum:0,
                surviveboy:0,
                survivegirl:0,



            },
            iscitydisabled:true,
            localitylist:[
                {
                    value:1,
                    label:'本地子女'
                },
                {
                    value:0,
                    label:'异地子女',
                },
            ],
             childindex:0,
             addchildRegionList:[],
            // 与父亲母亲关系
             fatherlist:[],
             // 身体状况
            physicallist:[],
           // 残疾类型
            disabilitytypeslist:[],
            // 残疾等级
            disabilitygradelist:[],
            // 是否收养
            adoptionlist:[
                    {
                    value:1,
                    label:'是'
                },
                {
                    value:0,
                    label:'否',
                },
            ],
            // 被收养人身份
            adoptedstatuslist:[],
                    
             editRules:{
                p1: [
                    { required: true, message: '请选择证件类型', trigger: 'change'  },
                ],
               
                p2: [
                    { required: true, message: '请输入证件号', trigger: 'blur' },
                    { validator: validatecard }
                //     {
                //         pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
                //         message: '请输入正确的证件号'
                //     },
                //    { validator: idCardValidity, trigger: 'blur' }
                ],
                 p3: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { validator: validatecards }
                ],
                p4: [
                    { required: true, message: '请选择性别', trigger: 'change'  },
                ],
                p5: [
                    { type: 'date', required: true, message: '请选择出生日期', trigger: 'change' }
                ],
                p6: [
                    { required: true, message: '请选择户口性质', trigger: 'change'  },
                ],
                p7: [
                    { required: true, message: '请选择婚姻状况', trigger: 'change'  },
                ],
               
                p8: [
                    { type: 'date', required: true, message: '请选择婚姻变动日期', trigger: 'change' }
                ],
                p10: [
                    { required: true, message: '请输入原户籍详情地址', trigger: 'blur' },
                    { validator: validatecards }
                ],
                // province01: [
                //     { required: true, message: '请选择省', trigger: 'change'  },
                // ],
                city01: [
                    { required: true, message: '请选择市', trigger: 'change'  },
                ],
                county01: [
                    { required: true, message: '请选择区/县', trigger: 'change'  },
                ],
                town01: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
                village01: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
                p11: [
                    { required: true, message: '请输入工作单位', trigger: 'blur' },
                    { validator: validatecards }
                ],
                op1: [
                    { required: true, message: '请选择证件类型', trigger: 'change'  },
                ],
                op2: [
                    { required: true, message: '请输入证件号', trigger: 'blur' },
                    { validator: validatecard }
                //      {
                //         pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
                //         message: '请输入正确的证件号'
                //     },
                //    { validator: idCardValidity, trigger: 'blur' }
                ],
                op3: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { validator: validatecards }
                ],
                op4: [
                    { required: true, message: '请选择性别', trigger: 'change'  },
                ],
                op5: [
                    { type: 'date', required: true, message: '请选择出生日期', trigger: 'change' }
                ],
                op6: [
                    { required: true, message: '请选择户口性质', trigger: 'change'  },
                ],
                op7: [
                    { required: true, message: '请选择婚姻状况', trigger: 'change'  },
                ],
               
                op8: [
                    { type: 'date', required: true, message: '请选择婚姻变动日期', trigger: 'change' }
                ],
                province02: [
                    { required: true, message: '请选择省', trigger: 'change'  },
                ],
                city02: [
                    { required: true, message: '请选择市', trigger: 'change'  },
                ],
                county02: [
                    { required: true, message: '请选择区/县', trigger: 'change'  },
                ],
                town02: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
                village02: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
                op10: [
                    { required: true, message: '请输入原户籍详情地址', trigger: 'blur' },
                    { validator: validatecards }
                ],
                tp1: [
                    { required: true, message: '请输入银行账号', trigger: 'blur' },
                    { validator: validatecards }
                ],
                tp2: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { validator: validatetel }
                ],
                province03: [
                    { required: true, message: '请选择省', trigger: 'change'  },
                ],
                city03: [
                    { required: true, message: '请选择市', trigger: 'change'  },
                ],
                county03: [
                    { required: true, message: '请选择区/县', trigger: 'change'  },
                ],
                town03: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
                village03: [
                    { required: true, message: '请选择街道/乡/镇', trigger: 'change'  },
                ],
                tp4: [
                    { required: true, message: '请输入现居住详情地址', trigger: 'blur' },
                    { validator: validatecards }
                ],
                 tp6: [
                    { required: true, message: '请输入退休账号', trigger: 'blur' },
                    { validator: validatecards }
                ],
                tp7: [
                    { required: true, message: '请输入退休金单位', trigger: 'blur' },
                    { validator: validatecards }
                ],



                 zp1: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { validator: validatecards }
                ],
             },
             lsRegionParentInfo1:0,
             lsRegionParentInfo2:0,
             lsRegionParentInfo3:0,
             lsRegionParentInfo4:1,
        }
    },
    watch:{
        'index':function(){
            console.log(11,this.index)
            this.editstep='1'
            this.resetForm()
            this.onpolicydeclarationinfomodelv2(this.RecordID,this.markID)
        },
        // 监听从父组件中filterShow传到子组件的val
        filterShow(val){
            this.flag=val
        }
  },
  created:async function(){
       await this.getRegionList(1,0)
    //  3政策措施类型 10证件类型,11养老保险类别,12与父亲关系,14身体状况,15残疾类型,16残疾等级,17被收养人身份
        // this.getSystemcodeinfogetlist(3)
        await this.getpolicymeasureinfoalllist()
        await this.getSystemcodeinfogetlist(10)
        await this.getSystemcodeinfogetlist(11)
        await this.getSystemcodeinfogetlist(12)
        await this.getSystemcodeinfogetlist(14)
        await  this.getSystemcodeinfogetlist(15)
        await  this.getSystemcodeinfogetlist(16)
        await this.getSystemcodeinfogetlist(17)
        await this.onpolicydeclarationinfomodelv2(this.RecordID,this.markID)
    },
    methods:{

               //获取城市列表
        async getRegionList(region_level,p_region_id) {
            await regionModule
                .regioninfogetlist(region_level,p_region_id)
                .then((response) => {
                switch (response.data.code) {
                    case 100:
                        if(this.lsRegionParentInfo1==1){
                            if(region_level==1){
                                this.provincelist01=response.data.result
                            
                            }else if(region_level==2){
                                this.citylist01=response.data.result
                            }else if(region_level==3){
                                this.countylist01=response.data.result
                            }else if(region_level==4){
                                this.townlist01=response.data.result
                            }else if(region_level==5){
                                this.villagelist01=response.data.result
                            }
                        }
                        if(this.lsRegionParentInfo2==1){
                           if(region_level==1){
                                this.provincelist02=response.data.result
                            }else if(region_level==2){
                                this.citylist02=response.data.result
                            }else if(region_level==3){
                                this.countylist02=response.data.result
                            }else if(region_level==4){
                                this.townlist02=response.data.result
                            }else if(region_level==5){
                                this.villagelist02=response.data.result
                            }
                        }
                         if(this.lsRegionParentInfo3==1){
                            if(region_level==1){
                                this.provincelist03=response.data.result
                            }else if(region_level==2){
                                this.citylist03=response.data.result
                            }else if(region_level==3){
                                this.countylist03=response.data.result
                            }else if(region_level==4){
                                this.townlist03=response.data.result
                            }else if(region_level==5){
                                this.villagelist03=response.data.result
                            }
                        }
                        if(this.lsRegionParentInfo4==1){
                            if(region_level==1){
                                this.provincelist04=response.data.result
                            }else if(region_level==2){
                                this.citylist04=response.data.result
                            }else if(region_level==3){
                                this.countylist04=response.data.result
                            }else if(region_level==4){
                                this.townlist04=response.data.result
                            }else if(region_level==5){
                                this.villagelist04=response.data.result
                            }
                        }

                        
                        if(this.regioninfogetlist==0){
                            if(region_level==1){
                                this.provincelist01=response.data.result
                                this.editForm.province01=410000000000
                                console.log(5555,this.editForm.province01)
                                this.regioninfogetlist=1
                                this.getRegionList(2,this.editForm.province01)
                                this.provincelist02=response.data.result
                                this.provincelist03=response.data.result
                                this.provincelist04=response.data.result
                            }
                        }else if(this.regioninfogetlist==1){
                            if(region_level==1){
                                this.provincelist01=response.data.result
                            }else if(region_level==2){
                                this.citylist01=response.data.result
                            }else if(region_level==3){
                                this.countylist01=response.data.result
                            }else if(region_level==4){
                                this.townlist01=response.data.result
                            }else if(region_level==5){
                                this.villagelist01=response.data.result
                            }
                        }
                        else if(this.regioninfogetlist==2){
                           if(region_level==1){
                                this.provincelist02=response.data.result
                            }else if(region_level==2){
                                this.citylist02=response.data.result
                            }else if(region_level==3){
                                this.countylist02=response.data.result
                            }else if(region_level==4){
                                this.townlist02=response.data.result
                            }else if(region_level==5){
                                this.villagelist02=response.data.result
                            }
                        }
                        else if(this.regioninfogetlist==3){
                            if(region_level==1){
                                this.provincelist03=response.data.result
                            }else if(region_level==2){
                                this.citylist03=response.data.result
                            }else if(region_level==3){
                                this.countylist03=response.data.result
                            }else if(region_level==4){
                                this.townlist03=response.data.result
                            }else if(region_level==5){
                                this.villagelist03=response.data.result
                            }
                        }else if(this.regioninfogetlist==4){
                            if(region_level==1){
                                this.provincelist04=response.data.result
                            }else if(region_level==2){
                                this.citylist04=response.data.result
                            }else if(region_level==3){
                                this.countylist04=response.data.result
                            }else if(region_level==4){
                                this.townlist04=response.data.result
                            }else if(region_level==5){
                                this.villagelist04=response.data.result
                            }
                        }
                    //this.toDeal(response.data.result);
                    break;
                    case 101:
                    break;
                    case 100002:
                       this.$message.error(baseconfig.no_permission_message);
                    break;
                    default:
                       this.$message.error(response.data.message);
                    break;  
                }
                })
                .catch((error) => {
                console.log("error", error);
                this.loading = false;
            });
        },
        //num1：1选择行政区划,2办公地址
        //num2：2市级,3省级
        //parentID,父级ID
        cityFormchange(index,num2,parentID) {
              this.regioninfogetlist=index;
                if(index==1){
                   switch (num2) {
                      case 2:
                          console.log("11111")
                          this.citylist01=[]; 
                          this.editForm.city01 = ""
                          this.countylist01 = [];
                          this.editForm.county01 = ""
                          this.townlist01=[]; 
                          this.editForm.town01 = ""
                          this.villagelist01=[]; 
                          this.editForm.village01 = ""
                     
                          this.getRegionList(2,parentID)
                          break;
                      case 3:
                          console.log("11111")
                          this.countylist01 = [];
                          this.editForm.county01 = ""
                          this.townlist01=[]; 
                          this.editForm.town01 = ""
                          this.villagelist01=[]; 
                          this.editForm.village01 = ""
                          this.citylist04.forEach(e=>{
                              if(parentID==e.value){
                                  this.adrss01=e.label
                              }
                          })
                          console.log('ssssssss111',this.adrss01)
                          this.getRegionList(3,parentID)
                          break;
                      case 4:
                          console.log("11111")
                           this.townlist01=[]; 
                          this.editForm.town01 = ""
                          this.villagelist01=[]; 
                          this.editForm.village01 = ""
                          this.getRegionList(4,parentID)
                          break;
                      case 5:
                          console.log("11111")
                          this.villagelist01=[]; 
                           this.editForm.village01 = ""
                           this.getRegionList(5,parentID)
                          break;
                      default:
                          break;
                 }
                 
                } else if(index==2){
                   switch (num2) {
                      case 2:
                          console.log("11111")
                          this.citylist02=[]; 
                          this.editForm.city02 = ""
                          this.countylist02 = [];
                          this.editForm.county02 = ""
                          this.townlist02=[]; 
                          this.editForm.town02 = ""
                          this.villagelist02=[]; 
                          this.editForm.village02 = ""
                          this.getRegionList(2,parentID)
                          break;
                      case 3:
                          console.log("11111")
                          this.countylist02 = [];
                          this.editForm.county02 = ""
                          this.townlist02=[]; 
                          this.editForm.town02 = ""
                          this.villagelist02=[]; 
                          this.editForm.village02 = ""
                           this.getRegionList(3,parentID)
                          break;
                      case 4:
                          console.log("11111")
                          this.townlist02=[]; 
                          this.editForm.town02 = ""
                          this.villagelist02=[]; 
                          this.editForm.village02 = ""
                          this.getRegionList(4,parentID)
                          break;
                      case 5:
                          console.log("11111")
                         this.villagelist02=[]; 
                          this.editForm.village02 = ""
                           this.getRegionList(5,parentID)
                          break;
                      default:
                          break;
                 }
                 
                } else if(index==3){
                   switch (num2) {
                      case 2:
                          console.log("11111")
                          this.citylist03=[]; 
                          this.editForm.city03 = ""
                          this.countylist03 = [];
                          this.editForm.county03 = ""
                          this.townlist03=[]; 
                          this.editForm.town03 = ""
                          this.villagelist03=[]; 
                          this.editForm.village03 = ""
                          
                          this.getRegionList(2,parentID)
                          break;
                      case 3:
                          console.log("11111")
                           this.countylist03 = [];
                          this.editForm.county03 = ""
                          this.townlist03=[]; 
                          this.editForm.town03 = ""
                          this.villagelist03=[]; 
                          this.editForm.village03 = ""
                           this.getRegionList(3,parentID)
                          break;
                      case 4:
                          console.log("11111")
                           this.townlist03=[]; 
                          this.editForm.town03 = ""
                          this.villagelist03=[]; 
                          this.editForm.village03 = ""
                          this.getRegionList(4,parentID)
                          break;
                      case 5:
                          console.log("11111")
                          this.villagelist03=[]; 
                          this.editForm.village03 = ""
                           this.getRegionList(5,parentID)
                          break;
                      default:
                          break;
                 }
                 
                }else if(index==4){
                   switch (num2) {
                      case 2:
                          console.log("11111")
                          this.citylist04=[]; 
                          this.editForm.city04 = ""
                          this.countylist04 = [];
                          this.editForm.county04 = ""
                          this.townlist04=[]; 
                          this.editForm.town04 = ""
                          this.villagelist04=[]; 
                          this.editForm.village04 = ""
                          this.getRegionList(2,parentID)
                          break;
                      case 3:
                          console.log("11111")
                         this.countylist04 = [];
                          this.editForm.county04 = ""
                          this.townlist04=[]; 
                          this.editForm.town04 = ""
                          this.villagelist04=[]; 
                          this.editForm.village04 = ""
                           this.getRegionList(3,parentID)
                          break;
                      case 4:
                          console.log("11111")
                         this.townlist04=[]; 
                          this.editForm.town04 = ""
                          this.villagelist04=[]; 
                          this.editForm.village04 = ""
                          this.getRegionList(4,parentID)
                          break;
                      case 5:
                          console.log("11111")
                          this.villagelist04=[]; 
                          this.editForm.village04 = ""
                          this.getRegionList(5,parentID)
                          break;
                      default:
                          break;
                 }
                 
                }


        },
        // 3政策措施类型下拉框
        async getpolicymeasureinfoalllist() {
            await policydeclarationinfoModule.policymeasureinfoalllist()
                .then((response) => {
                switch (response.data.code) {
                    case 100:{
                            let arr=[]
                            response.data.result.forEach(e=>{
                                let obj={
                                    value:e.policyMeasureID,
                                    label:e.pmP1
                                }
                                arr.push(obj)
                            })
                            this.searchForm.policylist=arr
                            console.log('this.searchForm.policylist',this.searchForm.policylist)
                        }
                    break;
                    
                }
                })
                .catch((error) => {
                console.log("error", error);
            });
        },
        //获取搜索框的 下拉框
        async getSystemcodeinfogetlist(mark) {
            //  3政策措施类型 10证件类型,11养老保险类别,12与父亲关系,14身体状况,15残疾类型,16残疾等级,17被收养人身份
            await systemcodeModule
                .systemcodeinfogetlist(mark)
                .then((response) => {
                    console.log(1111222,response)
                switch (response.data.code) {
                    case 100:{
                            let arr=[]
                            response.data.result.forEach(e=>{
                                let obj={
                                    value:e.systemCodeID,
                                    label:e.systemCodeName
                                }
                                arr.push(obj)
                            })
                            if(mark==3){
                                this.searchForm.policylist = arr
                            }else if(mark==10){
                                this.searchForm.certificatelist =arr
                                this.certificatelist =arr
                                this.searchForm.certificate=1
                            }else if(mark==11){
                                this.providelist= arr
                            }else if(mark==12){
                                this.fatherlist = arr
                            }else if(mark==14){
                                this.physicallist =arr
                            }else if(mark==15){
                                this.disabilitytypeslist =arr
                            }else if(mark==16){
                                this.disabilitygradelist =arr
                            }else if(mark==17){
                                this.adoptedstatuslist = arr
                            }
                        }
                    break;
                    case 100002:
                       this.$message.error(baseconfig.no_permission_message);
                    break;
                    default:
                       this.$message.error(response.data.message);
                    break;
                  }
                })
                .catch((error) => {
                console.log("error", error);
            });
        },
        //子女信息
        // 删除
        redlabel(k){
             if(this.editForm.childrenlist.length == 1){
                window.alert("最后一条无法删除")
                return
            }
            this.editForm.childrenlist.splice(k,1)
            this.editForm.plansum=this.editForm.childrenlist.length
            this.editForm.planboy=0
            this.editForm.plangirl=0
            this.editForm.surviveboy=0
            this.editForm.survivegirl=0
            this.editForm.survivesum=0
            let arr=[]
            let arr1=[]
            this.editForm.childrenlist.forEach(e=>{
                console.log(1111,e.zp2,e.zp7)
                if(e.zp7==2){
                    arr.push(e.zp7)
                }
                // 男孩
                if(e.zp2==1){
                   this.editForm.planboy++
                   console.log(this.editForm.planboy)
                }
                 if(e.zp2==2){
                   this.editForm.plangirl++
                }
                 if(e.zp2==1 && e.zp7!=4 && e.zp7!=''){
                   this.editForm.surviveboy++
                }
                 if(e.zp2==2 && e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivegirl++
                } 
                if( e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivesum++
                }
                if(e.zp5==2 || e.zp5==4 || e.zp6==2 || e.zp6==4){
                    arr1.push(e)
                }
            })
           
            if(arr.length>=1){
                this.isdisability=true
            }else{
                this.editForm.imgp38=[]
                this.editForm.p38=''
                this.isdisability=false
            }
            if(arr1.length>=1){
                this.isWhethertoadopt=true
            }else{
                this.editForm.imgp40=[]
                this.editForm.p40=''
                this.isWhethertoadopt=false
            }
        },
        //添加
        addlabel(){
           
            this.editForm.childrenlist.push(
                 {
                       ApplicationRecordID03:0,
                       zp1:'',
                       zp2:'',
                       zp3:'',
                       zp4:'',
                       zp5:'',
                       zp6:'',
                       zp7:'',
                       zp8:'',
                       zp9:'',
                       zp10:'',
                       zp11:'',
                       zp12:'',
                       zp13:'',
                       zp14:'是',
                       zp15:'',
                       zp16:'',
                       provincelist:[],
                       citylist:[],
                       countylist:[],
                       townlist:[],
                       villagelist:[],
                       province:'',
                       city:'',
                       county:'',
                       town:'',
                       village:'',
                       locality:'',
                   }
           )
            this.getchildRegionList(this.editForm.childrenlist.length-1,1,0)
            this.editForm.childrenlist[this.editForm.childrenlist.length-1].provincelist=this.addchildRegionList
            this.editForm.plansum=this.editForm.childrenlist.length
            this.editForm.planboy=0
            this.editForm.plangirl=0
            this.editForm.surviveboy=0
            this.editForm.survivegirl=0
            this.editForm.survivesum=0
            this.editForm.childrenlist.forEach((e,index)=>{
                console.log(1111,e.zp2,e.zp7)
                // 男孩
                if(e.zp2==1){
                   this.editForm.planboy++
                   console.log(this.editForm.planboy)
                }
                 if(e.zp2==2){
                   this.editForm.plangirl++
                }
                 if(e.zp2==1 && e.zp7!=4 && e.zp7!=''){
                   this.editForm.surviveboy++
                }
                 if(e.zp2==2 && e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivegirl++
                } 
                if( e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivesum++
                }
            })
        },
        // 性别变化
        changesex(index,item){
            console.log(5555,item)
            this.editForm.planboy=0
            this.editForm.plangirl=0
            this.editForm.surviveboy=0
            this.editForm.survivegirl=0
            this.editForm.survivesum=0
            this.editForm.childrenlist.forEach(e=>{
                console.log(1111,e,e.zp7)
                // 男孩
                if(e.zp2==1){
                   this.editForm.planboy++
                   console.log(this.editForm.planboy)
                }
                 if(e.zp2==2){
                   this.editForm.plangirl++
                }
                 if(e.zp2==1 && e.zp7!=4 && e.zp7!=''){
                   this.editForm.surviveboy++
                }
                 if(e.zp2==2 && e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivegirl++
                } 
                if( e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivesum++
                }
            })
                // plansum:1,
                // planboy:0,
                // plangirl:0,
                // // 现有存活
                // survivesum:0,
                // surviveboy:0,
                // survivegirl:0,
        },
        changesurvival(k,index){
            this.editForm.childrenlist[k].zp8=''
            this.editForm.childrenlist[k].zp9=''
            this.editForm.childrenlist[k].zp10=''
            this.editForm.childrenlist[k].zp11=''
            this.editForm.childrenlist[k].zp12=''
            this.editForm.childrenlist[k].zp13=''
            this.editForm.planboy=0
            this.editForm.plangirl=0
            this.editForm.surviveboy=0
            this.editForm.survivegirl=0
            this.editForm.survivesum=0
            let arr=[]
            this.editForm.childrenlist.forEach(e=>{
                console.log(1111,e.zp2,e.zp7)
                if(e.zp7==2){
                    arr.push(e.zp7)
                }
                // 男孩
                if(e.zp2==1){
                   this.editForm.planboy++
                   console.log(this.editForm.planboy)
                }
                 if(e.zp2==2){
                   this.editForm.plangirl++
                }
                 if(e.zp2==1 && e.zp7!=4 && e.zp7!=''){
                   this.editForm.surviveboy++
                }
                 if(e.zp2==2 && e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivegirl++
                } 
                if( e.zp7!=4 && e.zp7!=''){
                    this.editForm.survivesum++
                }
            })
            if(arr.length>=1){
                this.isdisability=true
            }else{
                this.editForm.imgp38=[]
                this.editForm.p38=''
                this.isdisability=false
            }
        },
        // 收养
        changeWhethertoadoptl(){
            let arr1=[]
             this.editForm.childrenlist.forEach(e=>{
                if(e.zp14==1){
                    arr1.push(e.zp14)
                }
            })
            if(arr1.length>=1){
                this.isWhethertoadopt=true
            }else{
                this.editForm.imgp40=[]
                this.editForm.p40=''
                this.isWhethertoadopt=false
            }
        },
        // 父亲母亲关心  显示 收养证图
        changefatherlist(){
            let arr1=[]
            this.editForm.childrenlist.forEach(item=>{
                if(item.zp5==2 || item.zp5==4 || item.zp6==2 || item.zp6==4){
                   arr1.push(item)
                }
            })
            if(arr1.length>=1){
                this.isWhethertoadopt=true
            }else{
                this.editForm.imgp40=[]
                this.isWhethertoadopt=false
            }
        },

        // 上传资料
        // 身份证
        uploadAddImglist1(obj) {
            console.log(obj)
            this.editForm.p31img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp31.push(imgObj);
            }
            this.editForm.p31=this.editForm.imgp31[0].url
        },
        DelImglist1(obj) {
            console.log(obj)
            this.editForm.p31img=false
            this.editForm.imgp31 = obj;
            this.editForm.p31=''
        },
        uploadAddImglist2(obj) {
            console.log(obj)
            this.editForm.p32img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp32.push(imgObj);
                this.editForm.p32=this.editForm.imgp32[0].url
            }
        },
        DelImglist2(obj) {
            console.log(obj)
            this.editForm.p32img=false
           this.editForm.imgp32= obj;
           this.editForm.p32=''
        },
        // 本人户口
        uploadAddImglist3(obj) {
            console.log(obj)
            this.editForm.p33img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp33.push(imgObj);
                this.editForm.p33=this.editForm.imgp33[0].url
            }
        },
        DelImglist3(obj) {
            console.log(obj)
           this.editForm.p33img=false
           this.editForm.imgp33 = obj;
           this.editForm.p33=''
        },
        uploadAddImglist4(obj) {
            console.log(obj)
            this.editForm.p34img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp34.push(imgObj);
            }
             this.editForm.p34=this.editForm.imgp34[0].url
        },
        DelImglist4(obj) {
            console.log(obj)
            this.editForm.p34img=false
           this.editForm.imgp34= obj;
            this.editForm.p34=''
        },
        // 配偶户口信息
        uploadAddImglist5(obj) {
            console.log(obj)
            this.editForm.p35img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp35.push(imgObj);
                this.editForm.p35=this.editForm.imgp35[0].url
            }
        },
        DelImglist5(obj) {
            console.log(obj)
           this.editForm.p35img=false
           this.editForm.imgp35 = obj;
            this.editForm.p35=''
        },
        uploadAddImglist6(obj) {
            console.log(obj)
             this.editForm.p36img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp36.push(imgObj);
            }
            this.editForm.p36=this.editForm.imgp36[0].url
        },
        DelImglist6(obj) {
            console.log(obj)
           this.editForm.p36img=false
           this.editForm.imgp36 = obj;
           this.editForm.p36=''
        },
        // 婚姻状况
        changemaritalstatus(){
            // this.editForm.op1=1
            // this.editForm.op2=''
            // this.editForm.op3=''
            // this.editForm.op4=''
            // this.editForm.op5=''
            // this.editForm.op6=''
            // this.editForm.op7=''
            // this.editForm.op8=''
            // this.editForm.op9=''
            // this.editForm.op10=''
            // this.editForm.province02=''
            // this.editForm.city02=''
            // this.editForm.county02=''
            // this.editForm.town02=''
            // this.editForm.village02=''
            // this.citylist02=[]
            // this.countylist02=[],
            // this.townlist02=[]
            // this.villagelist02=[]
        },

        // 独生子女证
        uploadAddImglist7(obj) {
            this.editForm.p37img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp37.push(imgObj);
            }
             this.editForm.p37=this.editForm.imgp37[0].url
        },
        DelImglist7(obj) {
          this.editForm.p37img=false
           this.editForm.imgp37 = obj;
           this.editForm.p37=''
        },
        // 残疾证明
        uploadAddImglist8(obj) {
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp38.push(imgObj);
            }
        },
        DelImglist8(obj) {
           this.editForm.imgp38= obj;
        },
        // 婚姻证明
        uploadAddImglist9(obj) {
            this.editForm.p39img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp39.push(imgObj);
            }
            this.editForm.p39=this.editForm.imgp39[0].url
        },
        DelImglist9(obj) {
           this.editForm.p39img=false
           this.editForm.imgp39 = obj;
           this.editForm.p39=''
        },
        uploadAddImglist10(obj) {
            // this.editForm.p40img=true
            for (let i = 0; i < obj.length; i++) {
                var imgObj = {
                url: obj[i].url,
                };
                this.editForm.imgp40.push(imgObj);
                this.editForm.p40=this.editForm.imgp40[0].url
            }
        },
        DelImglist10(obj) {
            // this.editForm.p40img=false
            this.editForm.imgp40 = obj;
            this.editForm.p40=''
        },
     
       
        // 提交  保存
        onsubmit(index,editForm){
             if(this.searchForm.policy==''){
                this.$message.error("请选择申报政策");
                return
             }
             this.$refs.editForm.validate(async valid=>{
                if(valid){
                    if(this.editForm.p31==''){
                            this.$message.error("请上传身份证正面");
                            return
                        }
                    if(this.editForm.p32==''){
                        this.$message.error("请上传身份证反面");
                        return
                    }
                    if(this.editForm.p33==''){
                        this.$message.error("请上传户口本人首页");
                        return
                    }
                    if(this.editForm.p34==''){
                        this.$message.error("请上传户口本人本人页");
                        return
                    }
                   
                    if(this.editForm.p7==1 || this.editForm.p7==2){
                        if(this.editForm.p35==''){
                            this.$message.error("请上传户口配偶首页");
                            return
                        }
                        if(this.editForm.p36==''){
                            this.$message.error("请上传配偶本人页");
                            return
                        }
                        if(this.editForm.p39==''){
                            this.$message.error("请上传婚姻证明信息");
                            return
                        }
                    }
                  
                    console.log(2222,this.editForm.imgp38)
                    if(this.isWhethertoadopt==true){
                        if(this.editForm.imgp40.length==0){
                            this.$message.error("请上传收养证");
                            return
                        }
                    }
                    
                    if(this.isdisability==true){
                        if(this.editForm.imgp38.length==0){
                            this.$message.error("请上传残疾证明信息");
                            return
                        }
                    }
                    // 本人身份证
                    if(this.Getsex(this.editForm.p2)!==this.editForm.p4){
                        this.$message.error("本人性别与身份证号不符");
                        return
                    }
                    if(this.GetBirthday(this.editForm.p2)!==this.editForm.p5){
                        this.$message.error("本人出生日期与身份证号不符");
                        return
                    }
                    // 配偶
                    if(this.Getsex(this.editForm.op2)!==this.editForm.op4){
                        this.$message.error("配偶性别与身份证号不符");
                        return
                    }
                    if(this.GetBirthday(this.editForm.op2)!==this.editForm.op5){
                        this.$message.error("配偶出生日期与身份证号不符");
                        return
                    }

                    //子女
                    let  Getsexlist=[]
                    let GetBirthdaylist=[]
                    for (var m = 0; m < this.editForm.childrenlist.length; m++) {
                        if(isIdentityId(this.editForm.childrenlist[m].zp4)!=''){
                            this.$message.error('输入子女的'+isIdentityId(this.editForm.childrenlist[m].zp4));
                            return
                        }
                        if (this.editForm.childrenlist[m].zp3!=this.GetBirthday(this.editForm.childrenlist[m].zp4)){
                            GetBirthdaylist.push(m)
                        }
                        if (this.editForm.childrenlist[m].zp2!=this.Getsex(this.editForm.childrenlist[m].zp4)){
                        Getsexlist.push(m)
                        }
                    }
                    if(Getsexlist.length>=1){
                        this.$message.error("子女性别与身份证号不符");
                        return
                    }
                    if(GetBirthdaylist.length>=1){
                        this.$message.error("子女出生日期与身份证号不符");
                        return
                    }
                    
                    // 身份证之间的重复
                    if(this.editForm.p7==1 || this.editForm.p7==2){
                        if(this.editForm.p2 ==this.editForm.op2){
                             this.$message.error("配偶身份证号与本人身份证号重复");
                             return
                        }
                    }
                    // 判断身份证是否重复
                    let selfcertificate=[]
                    let matecertificate=[]
                    let childrenlistzp4=[]
                     this.editForm.childrenlist.forEach(m=>{
                         if(this.editForm.p2==m.zp4){
                             selfcertificate.push(m)
                         }
                         if(this.editForm.op2==m.zp4){
                             matecertificate.push(m)
                         }
                         childrenlistzp4.push(m.zp4)
                         
                     })
                    if(selfcertificate.length >= 1){
                        this.$message.error('子女身份证号与本人身份证号重复')
                        return;
                    }
                    if(matecertificate.length >= 1){
                        this.$message.error('子女身份证号与配偶身份证号重复')
                        return;
                    }
                    let oneselfcertificate=[]
                    let c=[]
                    if(childrenlistzp4.length>1){
                        for (var i = 0; i < childrenlistzp4.length; i++) {
                            if (c.indexOf(childrenlistzp4[i]) === -1) {
                                c.push(childrenlistzp4[i]);
                            } else{
                                oneselfcertificate.push(childrenlistzp4[i]);
                            }
                        }
                        if(oneselfcertificate.length >= 1){
                            this.$message.error('子女与子女之间身份证号有重复')
                            return;
                        }
                    }
                    
                   
                    // 半边户  本人 和配偶的判断   一致否   不一致 是
                    //   子女    this.translucence=0   传0
                    if(this.editForm.p7==1 || this.editForm.p7==2){
                        if(this.editForm.p6==this.editForm.op6){
                            this.translucence=0
                        }else{
                            this.translucence=1
                        }
                    }
                    // 地区
                        let province1=""
                        this.provincelist01.forEach(e=>{
                            if(this.editForm.province01==e.baseRegionID){
                                province1=e.baseRegionName
                            }
                        })
                        let city1=''
                        this.citylist01.forEach(e=>{
                            if(this.editForm.city01==e.baseRegionID){
                                city1=e.baseRegionName
                            }
                        })
                        let county1=''
                        this.countylist01.forEach(e=>{
                            if(this.editForm.county01==e.baseRegionID){
                                county1=e.baseRegionName
                            }
                        })
                        let town1=''
                        this.townlist01.forEach(e=>{
                            if(this.editForm.town01==e.baseRegionID){
                                town1=e.baseRegionName
                            }
                        })
                        let village1=''
                        this.villagelist01.forEach(e=>{
                            if(this.editForm.village01==e.baseRegionID){
                                village1=e.baseRegionName
                            }
                        })
                        // if(this.editForm.p10==''|| this.editForm.p10==undefined){
                        //     this.adrss01=province1+","+city1+","+county1+","+town1+","+village1
                        // }else{
                        //     this.adrss01=province1+","+city1+","+county1+","+town1+","+village1+","+this.editForm.p10
                        // }
                        if(this.editForm.p10==''|| this.editForm.p10==undefined){
                            
                            this.adrss01=province1+"·"+city1+"·"+county1+"·"+town1+"·"+village1
                        }else{
                            this.adrss01=province1+"·"+city1+"·"+county1+"·"+town1+"·"+village1+"·"+this.editForm.p10
                        }
                        console.log(111,this.adrss01)
                        
                  
                        // 地区
                        let province3=""
                        this.provincelist03.forEach(e=>{
                            if(this.editForm.province03==e.baseRegionID){
                                province3=e.baseRegionName
                            }
                        })
                        let city3=''
                        this.citylist03.forEach(e=>{
                            if(this.editForm.city03==e.baseRegionID){
                                city3=e.baseRegionName
                            }
                        })
                        let county3=''
                        this.countylist03.forEach(e=>{
                            if(this.editForm.county03==e.baseRegionID){
                                county3=e.baseRegionName
                            }
                        })
                        let town3=''
                        this.townlist03.forEach(e=>{
                            if(this.editForm.town03==e.baseRegionID){
                                town3=e.baseRegionName
                            }
                        })
                        let village3=''
                        this.villagelist03.forEach(e=>{
                            if(this.editForm.village03==e.baseRegionID){
                                village3=e.baseRegionName
                            }
                        })
                        // if(this.editForm.tp4==''|| this.editForm.tp4==undefined){
                        //     this.adrss03=province3+","+city3+","+county3+","+town3+","+village3
                        // }else{
                        //    this.adrss03=province3+","+city3+","+county3+","+town3+","+village3+","+this.editForm.tp4
                        // }
                        if(this.editForm.tp4==''|| this.editForm.tp4==undefined){
                            this.adrss03=province3+"·"+city3+"·"+county3+"·"+town3+"·"+village3
                        }else{
                           this.adrss03=province3+"·"+city3+"·"+county3+"·"+town3+"·"+village3+"·"+this.editForm.tp4
                        }
                        console.log(2222,this.adrss03)

                        if(this.editForm.p7==1 || this.editForm.p7==2){
                            // 地区
                            let province2=""
                            this.provincelist02.forEach(e=>{
                                if(this.editForm.province02==e.baseRegionID){
                                    province2=e.baseRegionName
                                }
                            })
                            let city2=''
                            this.citylist02.forEach(e=>{
                                if(this.editForm.city02==e.baseRegionID){
                                    city2=e.baseRegionName
                                }
                            })
                            let county2=''
                            this.countylist02.forEach(e=>{
                                if(this.editForm.county02==e.baseRegionID){
                                    county2=e.baseRegionName
                                }
                            })
                            let town2=''
                            this.townlist02.forEach(e=>{
                                if(this.editForm.town02==e.baseRegionID){
                                    town2=e.baseRegionName
                                }
                            })
                            let village2=''
                            this.villagelist02.forEach(e=>{
                                if(this.editForm.village02==e.baseRegionID){
                                    village2=e.baseRegionName
                                }
                            })
                            // if(this.editForm.op10=='' || this.editForm.op10==undefined ){
                            //     this.adrss02=province2+","+city2+","+county2+","+town2+","+village2
                            // }else{
                            //     this.adrss02=province2+","+city2+","+county2+","+town2+","+village2+","+this.editForm.op10
                            // }
                            if(this.editForm.op10=='' || this.editForm.op10==undefined ){
                                this.adrss02=province2+"·"+city2+"·"+county2+"·"+town2+"·"+village2
                            }else{
                                this.adrss02=province2+"·"+city2+"·"+county2+"·"+town2+"·"+village2+"·"+this.editForm.op10
                            }
                         
                            console.log('3333',this.adrss02)
                        } 
                        if(this.editForm.p7==1 || this.editForm.p7==2){
                            if(this.editForm.p6==this.editForm.op6){
                                this.translucence=0
                            }else{
                                this.translucence=1
                            }
                        }
                   



                    let applyuserjson=[] 
                    if(this.searchForm.policy==2  ||this.searchForm.policy==1){
                        this.editForm.tp5=0
                        this.editForm.tp6=''
                        this.editForm.village04=0
                        this.editForm.tp7=''
                        this.editForm.tp8=0
                        this.editForm.tp9=0
                        this.editForm.tp10=0
                        this.editForm.tp11=''
                    } 
                    if(this.editForm.tp5==''){
                        this.editForm.tp5=0
                    } 
                    if(this.editForm.village04==''){
                       this.editForm.village04=0
                    } 
                    if(this.editForm.tp8==''){
                       this.editForm.tp8=0
                    } 
                    if(this.editForm.tp9==''){
                       this.editForm.tp9=0
                    } 
                    if(this.editForm.tp10==''){
                       this.editForm.tp10=0
                    } 
                    let apply_user_typefater=0
                    let apply_user_typemater=0
                    if(Number(this.editForm.p4)==1) {
                        apply_user_typefater=1
                        apply_user_typemater=2
                    }else{
                        apply_user_typefater=2
                        apply_user_typemater=1
                    } 
                    // 社保与户籍类型
                    let social_security_census_type=0
                    let isProvince1=0
                    let isProvince2=0
                    this.villagelist01.forEach(e=>{
                        if(this.editForm.village01==e.baseRegionID){
                            isProvince1=e.isProvince
                        }
                    })
                    this.villagelist04.forEach(e=>{
                        if(this.editForm.village04==e.baseRegionID){
                            isProvince2=e.isProvince
                        }
                    })
                    if(this.searchForm.policy==3){
                        if(this.editForm.village04==0 ||this.editForm.village04=='' || this.editForm.village04==undefined){
                            social_security_census_type=0
                            this.editForm.village04=0
                        }else{
                            if(isProvince1==1 && isProvince2==1){
                                social_security_census_type=1
                            }else if(isProvince1==1 && isProvince2==0){
                                social_security_census_type=2
                            }else if(isProvince1==0 && isProvince2==1){
                                social_security_census_type=3
                            }else if(isProvince1==0 && isProvince2==0){
                                social_security_census_type=4
                            }
                        }
                        
                       
                    }
                    console.log(4141444,social_security_census_type)

                    // 本人
                    let Myinformation=
                        {
                        // 申请记录id
                        apply_user_id:this.ApplicationRecordID,
                        //姓名
                        real_name:this.editForm.p3,
                        // 性别
                        sex_id:Number(this.editForm.p4),
                        // 出生日期
                        user_birthday:this.editForm.p5,
                        // 证件类型
                        certificate_type:Number(this.editForm.p1),
                        // 证件号
                        certificate_no:this.editForm.p2,
                        // 户口性质（1农业；2非农业）
                        account_nature:Number(this.editForm.p6),
                        // 半边户（0否1是）
                        is_half_home:Number(this.translucence),
                        // 婚姻状况（1初婚；2再婚；3离婚；4丧偶）
                        marital_status:Number(this.editForm.p7),
                        // 婚姻变动年月
                        marriage_changes:this.editForm.p8,
                        //享受地户籍（行政区划，到村）
                        enjoy_census:this.editForm.village01,
                        // 原户籍地址详情
                        enjoy_census_address:this.adrss01,
                        // 现户籍地址（行政区划，到村）
                        current_census:this.editForm.village03,
                        // 现户籍地址详情
                        current_census_address:this.adrss03,
                        // 工作单位
                        work_unit:this.editForm.p11,
                        // 联系电话
                        contact_tel:this.editForm.tp2,
                        // 养老保险类别（1城镇职工；2城乡居民）
                        pension_insurance_category:Number(this.editForm.tp5),
                        // 退休证号
                        retirement_certificate_number:this.editForm.tp6,
                        // 退休金（养老金）发放地（行政区划到组）
                        retirement_grant_land:this.editForm.village04,
                        // 退休金（养老金）发放单位
                        retirement_payment_unit:this.editForm.tp7,
                        // 退休年月
                        retirement_time:this.editForm.tp8,
                        // 户口迁入本省年月
                        census_move_in_time:this.editForm.tp9,
                        // 户口迁出本省年月
                        census_move_out_time:this.editForm.tp10,
                        // 户口迁出地
                        census_emigration_place:this.editForm.tp11,
                        // 是否本地子女(0:否1:是)
                        is_local_child:-1,
                        // 与父亲关系
                        relationship_father:0,
                        // 与母亲关系
                        relationship_mother:0,
                        // 与身体状况
                        physical_conditions:0,
                        // 残疾证号码
                        disability_certificate_num:'',
                        // 残疾类型
                        disability_type:0,
                        // 残疾等级
                        disability_level:0,
                        // 残疾日期
                        disability_time:0,
                        // 死亡确认单位
                        death_confirmation_unit:"",
                        // 死亡日期
                        death_time:0,
                        // 是否收养（0否1是）
                        is_adoption:0,
                        // 收养年月
                        adoption_time:0,
                        // 被收养人身份
                        adoptee_status:0,
                       
                        // 人员类型（1:父亲，2:母亲，3:子女）
                        apply_user_type:apply_user_typefater,
                        bank_account:this.editForm.tp1,
                        social_security_census_type:social_security_census_type,
                    }
                    applyuserjson.push(Myinformation)
                    console.log('本人',applyuserjson)
                  
                    if(this.editForm.p7==1 || this.editForm.p7==2){
                         // 配偶
                    let spouseinformation=
                        {
                        // 申请记录id
                        apply_user_id:this.ApplicationRecordID02,
                        //姓名
                        real_name:this.editForm.op3,
                        // 性别
                        sex_id:Number(this.editForm.op4),
                        // 出生日期
                        user_birthday:this.editForm.op5,
                        // 证件类型
                        certificate_type:Number(this.editForm.op1),
                        // 证件号
                        certificate_no:this.editForm.op2,
                        // 户口性质（1农业；2非农业）
                        account_nature:Number(this.editForm.op6),
                        // 半边户（0否1是）
                        is_half_home:Number(this.translucence),
                        // 婚姻状况（1初婚；2再婚；3离婚；4丧偶）
                        marital_status:Number(this.editForm.op7),
                        // 婚姻变动年月
                        marriage_changes:this.editForm.op8,
                        //享受地户籍（行政区划，到村）
                        enjoy_census:this.editForm.village02,
                        // 原户籍地址详情
                        enjoy_census_address:this.adrss02,
                        // 现户籍地址（行政区划，到村）
                        current_census:0,
                        // 现户籍地址详情
                        current_census_address:'',
                        // 工作单位
                        work_unit:'',
                        // 联系电话
                        contact_tel:0,
                        // 养老保险类别（1城镇职工；2城乡居民）
                        pension_insurance_category:0,
                        // 退休证号
                        retirement_certificate_number:'',
                        // 退休金（养老金）发放地（行政区划到组）
                        retirement_grant_land:0,
                        // 退休金（养老金）发放单位
                        retirement_payment_unit:'',
                        // 退休年月
                        retirement_time:0,
                        // 户口迁入本省年月
                        census_move_in_time:0,
                        // 户口迁出本省年月
                        census_move_out_time:0,
                        // 户口迁出地
                        census_emigration_place:0,
                        // 是否本地子女(0:否1:是)
                        is_local_child:-1,
                        // 与父亲关系
                        relationship_father:0,
                        // 与母亲关系
                        relationship_mother:0,
                        // 与身体状况
                        physical_conditions:0,
                        // 残疾证号码
                        disability_certificate_num:'',
                        // 残疾类型
                        disability_type:0,
                        // 残疾等级
                        disability_level:0,
                        // 残疾日期
                        disability_time:0,
                        // 死亡确认单位
                        death_confirmation_unit:"",
                        // 死亡日期
                        death_time:0,
                        // 是否收养（0否1是）
                        is_adoption:0,
                        // 收养年月
                        adoption_time:0,
                        // 被收养人身份
                        adoptee_status:0,
                        // 人员类型（1:本人，2:配偶，3:子女）
                        apply_user_type:apply_user_typemater,
                        bank_account:'',
                        social_security_census_type:0,
                    }
                    applyuserjson.push(spouseinformation)
                    }
                   
                    // 子女
                    // 
                    this.editForm.childrenlist.forEach(e=>{
                        
                        if(e.zp9==''|| e.zp9==null){
                            e.zp9=0
                        }
                        if(e.zp10=='' || e.zp10==null){
                            e.zp10=0
                        }
                        if(e.zp11==''|| e.zp11==null){
                            e.zp11=0
                        }
                        if(e.zp13==''|| e.zp13==null){
                            e.zp13=0
                        }
                        if(e.zp15==''|| e.zp15==null){
                            e.zp15=0
                        }
                        if(e.zp16==''|| e.zp16==null){
                            e.zp16=0
                        }
                        if(e.zp7==4){
                            e.zp8=''
                            e.zp10=0
                            e.zp9=0
                            e.zp11=0
                        }
                        if(e.zp7==2){
                            e.zp12=''
                            e.zp13=0
                        }
                        if(e.village==''){
                            e.village=0
                        }
                        // if(e.zp14==0){
                        //     e.zp15=0
                        //     e.zp16=0
                        // }
                        if(e.zp5==2 || e.zp5==4 || e.zp6==2 || e.zp6==4){
                            if(e.zp14=='是'){
                              e.zp14=1
                           }
                        }
                        if((e.zp5==1 || e.zp5==3) && (e.zp6==1 || e.zp6==3)){
                            e.zp14=0,
                            e.zp15=0,
                            e.zp16=0
                        }
                        // 政策为城镇时
                        if(this.searchForm.policy==3){
                            e.locality=-1
                        }
                        
                        
                        let obj=
                            {
                            // 申请记录id
                            apply_user_id:e.ApplicationRecordID03,
                            //姓名
                            real_name:e.zp1,
                            // 性别
                            sex_id:Number(e.zp2),
                            // 出生日期
                            user_birthday:e.zp3,
                            // 证件类型
                            certificate_type:1,
                            // 证件号
                            certificate_no:e.zp4,
                            // 户口性质（1农业；2非农业）
                            account_nature:0,
                            // 半边户（0否1是）
                            is_half_home:0,
                            // 婚姻状况（1初婚；2再婚；3离婚；4丧偶）
                            marital_status:0,
                            // 婚姻变动年月
                            marriage_changes:0,
                            //享受地户籍（行政区划，到村）
                            enjoy_census:e.village,
                            // 原户籍地址详情
                            enjoy_census_address:'',
                            // 现户籍地址（行政区划，到村）
                            current_census:0,
                            // 现户籍地址详情
                            current_census_address:'',
                            // 工作单位
                            work_unit:'',
                            // 联系电话
                            contact_tel:0,
                            // 养老保险类别（1城镇职工；2城乡居民）
                            pension_insurance_category:0,
                            // 退休证号
                            retirement_certificate_number:'',
                            // 退休金（养老金）发放地（行政区划到组）
                            retirement_grant_land:0,
                            // 退休金（养老金）发放单位
                            retirement_payment_unit:'',
                            // 退休年月
                            retirement_time:0,
                            // 户口迁入本省年月
                            census_move_in_time:0,
                            // 户口迁出本省年月
                            census_move_out_time:0,
                            // 户口迁出地
                            census_emigration_place:'',
                             // 是否本地子女(0:否1:是)
                             is_local_child:Number(e.locality),
                            // 与父亲关系
                            relationship_father:Number(e.zp5),
                            // 与母亲关系
                            relationship_mother:Number(e.zp6),
                            // 与身体状况
                            physical_conditions:Number(e.zp7),
                            // 残疾证号码
                            disability_certificate_num:e.zp8,
                            // 残疾类型
                            disability_type:Number(e.zp9),
                            // 残疾等级
                            disability_level:Number(e.zp10),
                            // 残疾日期
                            disability_time:e.zp11,
                            // 死亡确认单位
                            death_confirmation_unit:e.zp12,
                            // 死亡日期
                            death_time:e.zp13,
                            // 是否收养（0否1是）
                            is_adoption:Number(e.zp14),
                            // 收养年月
                            adoption_time:e.zp15,
                            // 被收养人身份
                            adoptee_status:e.zp16,
                            // 人员类型（1:本人，2:配偶，3:子女）
                            apply_user_type:3,
                            bank_account:'',
                            social_security_census_type:0,
                        }
                        applyuserjson.push(obj)
                    })


                    // 是否独生子女证
                    let is_receive_single_child_card=0
                    if(this.editForm.p37!=''){
                        is_receive_single_child_card=1
                    }
                    let applyhousejson=
                        {
                        apply_house_id:this.applyhouseid,
                        is_receive_single_child_card:is_receive_single_child_card,
                         // 计划生育及收养子女数
                        total_children_num: this.editForm.plansum,
                        // 计划生育及收养男孩数
                        total_children_boy_num:this.editForm.planboy,
                        // 计划生育及收养女孩数
                        total_children_girl_num:this.editForm.plangirl,
                        // 现有存活子女数
                        survive_children_num:this.editForm.survivesum,
                        // 现有存活子女男孩数
                        survive_children_boy_num:this.editForm.surviveboy,
                        // 现有存活子女女孩数
                        survive_children_girl_num:this.editForm.survivegirl,
                        }
                    
                    
                    // 图集图片类型（1本人身份证正面；2本人身份证反面；3本人户口首页；4本人户口本人也；5配偶户口首页；6配偶户口本人页；7婚姻证明；8独生子女光荣证；9残疾证；10收养证）
                   // 图集图片类型（1本人身份证正面；2本人身份证反面；3本人户口首页；4本人户口本人也；5配偶户口首页；6配偶户口本人页；7婚姻证明；8独生子女光荣证；9残疾证；10收养证）
                    let applyusergalleryjson=[]
                    applyusergalleryjson=[
                        {
                            gallery_type:1,
                            gallery_url:this.editForm.imgp31[0].url
                        },
                        {
                            gallery_type:2,
                            gallery_url:this.editForm.imgp32[0].url
                        },
                        {
                            gallery_type:3,
                            gallery_url:this.editForm.imgp33[0].url
                        },
                        {
                            gallery_type:4,
                            gallery_url:this.editForm.imgp34[0].url
                        },
                        
                    ]
                    if(this.editForm.p37!=''){
                        let imglist= {
                            gallery_type:8,
                            gallery_url:this.editForm.imgp37[0].url
                        }
                         applyusergalleryjson.push(imglist)
                    }
                       7
                    // 配偶
                    if(this.editForm.p7==1 || this.editForm.p7==2){
                        let obj1={
                            gallery_type:5,
                            gallery_url:this.editForm.imgp35[0].url
                        }
                        applyusergalleryjson.push(obj1 )
                        let obj2={
                            gallery_type:6,
                            gallery_url:this.editForm.imgp36[0].url
                        }
                        
                        applyusergalleryjson.push(obj2)
                         let obj3={
                            gallery_type:7,
                            gallery_url:this.editForm.imgp39[0].url
                        }
                        applyusergalleryjson.push(obj3 )
                    }
                    // 收养
                    if(this.isWhethertoadopt==true){
                          this.editForm.imgp40.forEach(item=>{
                            let obj={
                                gallery_type:10,
                                gallery_url:item.url
                            }
                            applyusergalleryjson.push(obj)
                        })
                    }
                  
                    // 残疾
                    if(this.isdisability==true){
                         this.editForm.imgp38.forEach(item=>{
                            let obj={
                                gallery_type:9,
                                gallery_url:item.url
                            }
                            applyusergalleryjson.push(obj)
                        })
                    }
                     console.log('0000000',applyuserjson,JSON.stringify(applyhousejson))
                    console.log('11111111',applyuserjson,JSON.stringify(applyuserjson))
                    console.log('222222',JSON.stringify(applyusergalleryjson))
                    let original_value_json=[]
                    console.log(66666666,this.ApplicationRecordID)
                    if(index==0){
                        await policydeclarationinfoModule.policydeclarationinfo(
                                JSON.stringify(applyhousejson),
                                JSON.stringify(applyuserjson),
                                JSON.stringify(applyusergalleryjson),
                                this.searchForm.policy,
                                index,
                                JSON.stringify(original_value_json),
                                this.markID)
                            .then((response) => {
                                switch (response.data.code) {
                                case 100:
                                    {
                                        const h = this.$createElement;
                                        this.$notify({
                                            title: "成功",
                                            message: h("span", "保存成功"),
                                            type: "success",
                                        });
                                        this.flag= false;
                                        this.$emit("getState", this.flag); 
                                       
                                    }
                                    break;
                                case 100002:
                                   this.$message.error(baseconfig.no_permission_message);
                                break;
                                default:
                                    this.$message.error(response.data.message);
                                break;
                                }
                            })
                            .catch((error) => {});
                    }else{
                         await policydeclarationinfoModule.
                            policydeclarationinfo(
                                JSON.stringify(applyhousejson),
                                JSON.stringify(applyuserjson),
                                JSON.stringify(applyusergalleryjson),
                                this.searchForm.policy,
                                11,
                                JSON.stringify(original_value_json),
                                this.markID)
                            .then((response) => {
                                switch (response.data.code) {
                                case 100:
                                    {
                                        const h = this.$createElement;
                                        this.$notify({
                                            title: "成功",
                                            message: h("span", "提交成功"),
                                            type: "success",
                                        }); 
                                        this.flag= false;
                                        this.$emit("getState", this.flag); 
                                        
                                    }
                                    break;
                               case 100002:
                                  this.$message.error(baseconfig.no_permission_message);
                                break;
                                default:
                                   this.$message.error(response.data.message);
                                break;
                                }
                            })
                            .catch((error) => {});
                    }
                }else{
                return false
             }
            }) 
        
        },
        // 重置
        resetForm(){
           this.searchForm.policy=''
            this.searchForm.identitynum=''
            this.regioninfogetlist=0,
            this.lsRegionParentInfo1=0
            this.lsRegionParentInfo2=0
            this.lsRegionParentInfo3=0
            this.lsRegionParentInfo4=1
            this.adrss01=''
            this.adrss02=''
            this.adrss03=''
            this.adrss04=''
            this.applyRecordID=0
            this.ApplicationRecordID=0
            this.ApplicationRecordID02=0
            this.isCanSubmit=1
            this.citylist01=[]
            this.countylist01=[]
            this.townlist01=[]
            this.villagelist01=[]
            this.citylist02=[]
            this.countylist02=[],
            this.townlist02=[]
            this.villagelist02=[]
            this.citylist03=[]
            this.countylist03=[]
            this.townlist03=[]
            this.villagelist03=[]
            this.citylist04=[]
            this.countylist04=[]
            this.townlist04=[]
            this.villagelist04=[]
            this.editForm.p31='',
            this.editForm.p31img=false,
            this.editForm.imgp31=[],
            this.editForm.p32='',
            this.editForm.p32img=false,
            this.editForm.imgp32=[],
            this.editForm.p33='',
            this.editForm.p33img=false,
            this.editForm.imgp33=[],
            this.editForm.p34='',
            this.editForm.p34img=false,
            this.editForm.imgp34=[],
            this.editForm.p35='',
            this.editForm.p35img=false,
            this.editForm.imgp35=[],
            this.editForm.p36='',
            this.editForm.imgp36=[],
            this.editForm.p36img=false,
            this.editForm.p37='',
            this.editForm.imgp37=[],
            this.editForm.p37img=false,
            this.editForm.p38='',
            this.editForm.imgp38=[],
            this.editForm.p39='',
            this.editForm.imgp39=[],
            this.editForm.p39img=false,
            this.editForm.p40='',
            this.editForm.imgp40=[],
            this.editForm.p40img=false
            this.editForm.childrenlist[0].provincelist=this.addchildRegionList
            this.isdisabled=false
            this.isWhethertoadopt=false
            this.isdisability=false
            this.editForm.op1=1
            this.editForm.op2=''
            this.editForm.op3=''
            this.editForm.op4=''
            this.editForm.op5=''
            this.editForm.op6=''
            this.editForm.op7=''
            this.editForm.op8=''
            this.editForm.op9=''
            this.editForm.op10=''
            this.editForm.province02=''
            this.editForm.city02=''
            this.editForm.county02=''
            this.editForm.town02=''
            this.editForm.village02=''
            this.citylist02=[]
            this.countylist02=[],
            this.townlist02=[]
            this.villagelist02=[]
            // 其他信息
            this.editForm.province04=''
            this.editForm.city04=''
            this.editForm.county04=''
            this.editForm.town04=''
            this.editForm.village04=''
        },
          //详情
        async onpolicydeclarationinfomodelv2(apply_record_id,mark){
           
           
            //  410928196001016021
            this.isonsubmit=false
            await policydeclarationinfoModule.policydeclarationinfomodelv2(apply_record_id,mark).then((response) => {
                    switch (response.data.code) {
                    case 100:
                        {
                        this.editForm.childrenlist=[]
                            this.isdisabled=true
                            console.log('response.data.result',response.data.result)
                            this.searchForm.policy=response.data.result.policyMeasureID 
                            this.applyhouseid=response.data.result.applyHouseID
                            this.isCanSubmit=response.data.result.isCanSubmit
                            console.log('this.ApplicationRecordID',this.ApplicationRecordID)
                            response.data.result.lsHouse.forEach(item=>{
                                this.editForm.plansum=item.totalChildrenNum
                                this.editForm.planboy=item.totalChildrenBoyNum
                                this.editForm.plangirl=item.totalChildrenGirlNum
                                this.editForm.survivesum=item.surviveChildrenNum
                                this.editForm.survivegirl=item.surviveChildrenGirlNum
                                this.editForm.surviveboy=item.surviveChildrenBoyNum
                            })
                                 
                                    // lsHouse
                            response.data.result.lsUser01.forEach(item=>{
                                // 本人配偶
                                if(item.applyUserType!==3){
                                    if(response.data.result.applyUserID==item.applyUserID){
                                         console.log('本人')
                                         if(item.pensionInsuranceCategory==0){
                                             item.pensionInsuranceCategory=''
                                         }

                                        //    // 本人信息
                                        this.ApplicationRecordID=item.applyUserID
                                        this.editForm.p1=item.certificateType
                                        this.editForm.p2=item.certificateNo
                                        this.editForm.p3=item.realName
                                        this.editForm.p4=item.sexID
                                        this.editForm.p5=item.userBirthday
                                        this.editForm.p6=item.accountNature
                                        this.editForm.p7=item.maritalStatus
                                        this.editForm.p8=item.marriageChanges
                                        // this.editForm.p10=item.enjoyCensusAddress.split(",")[5]
                                          this.editForm.p10=item.enjoyCensusAddress.split("·")[5]
                                        this.editForm.p11=item.workUnit
                                        // this.editForm.tp4=item.currentCensusAddress.split(",")[5]
                                          this.editForm.tp4=item.currentCensusAddress.split("·")[5]
                                        this.editForm.tp1=item.bankAccount
                                        this.editForm.tp2=item.contactTel
                                        this.editForm.tp5=item.pensionInsuranceCategory
                                        this.editForm.tp6=item.retirementCertificateNumber
                                        this.editForm.tp7=item.retirementPaymentUnit
                                        this.editForm.tp8=item.retirementTime
                                        this.editForm.tp9=item.censusMoveInTime
                                        this.editForm.tp10=item.censusMoveOutTime
                                        this.editForm.tp11=item.censusEmigrationPlace

                                        console.log('item.lsRegionParentInfo1',item.lsRegionParentInfo1[0])
                                        // 享受地
                                        item.lsRegionParentInfo1.forEach(m=>{
                                            this.lsRegionParentInfo1=1
                                            this.getRegionList(2,m.provinceID)
                                            this.getRegionList(3,m.cityID)
                                            this.getRegionList(4,m.districtID)
                                            this.getRegionList(5,m.townshipID)
                                            this.editForm.province01=m.provinceID
                                            this.editForm.city01=m.cityID
                                            this.editForm.county01=m.districtID
                                            this.editForm.town01=m.townshipID
                                            this.editForm.village01=m.villageID
                                        
                                        })
                                        // 现居地
                                        item.lsRegionParentInfo2.forEach(m=>{
                                            this.lsRegionParentInfo3=1
                                            this.getRegionList(2,m.provinceID)
                                            this.getRegionList(3,m.cityID)
                                            this.getRegionList(4,m.districtID)
                                            this.getRegionList(5,m.townshipID)
                                            this.editForm.province03=m.provinceID
                                            this.editForm.city03=m.cityID
                                            this.editForm.county03=m.districtID
                                            this.editForm.town03=m.townshipID
                                            this.editForm.village03=m.villageID
                                        })
                                        // 退休地
                                        item.lsRegionParentInfo3.forEach(m=>{
                                            this.lsRegionParentInfo4=1
                                            this.getRegionList(2,m.provinceID)
                                            this.getRegionList(3,m.cityID)
                                            this.getRegionList(4,m.districtID)
                                            this.getRegionList(5,m.townshipID)
                                            if(m.provinceID!=0){
                                                 this.editForm.province04=m.provinceID
                                            }
                                            if(m.cityID!=0){
                                                 this.editForm.city04=m.cityID
                                            }
                                            if(m.districtID!=0){
                                                 this.editForm.town04=m.districtID
                                            }
                                            if(m.townshipID!=0){
                                                 this.editForm.county04=m.townshipID
                                            }
                                            if(m.villageID!=0){
                                                 this.editForm.village04=m.villageID
                                            }
                                        })
                                        
                                    }else{
                                         console.log('配偶')
                                        this.ApplicationRecordID02=item.applyUserID
                                        this.editForm.op1=item.certificateType
                                        this.editForm.op2=item.certificateNo
                                        this.editForm.op3=item.realName
                                        this.editForm.op4=item.sexID
                                        this.editForm.op5=item.userBirthday
                                        this.editForm.op6=item.accountNature
                                        this.editForm.op7=item.maritalStatus
                                        this.editForm.op8=item.marriageChanges
                                        // this.editForm.op10=item.enjoyCensusAddress.split(",")[5]
                                        this.editForm.op10=item.enjoyCensusAddress.split("·")[5]
                                        // 享受地
                                        item.lsRegionParentInfo1.forEach(m=>{
                                            this.getRegionList(2,m.provinceID)
                                            this.getRegionList(3,m.cityID)
                                            this.getRegionList(4,m.districtID)
                                            this.getRegionList(5,m.townshipID)
                                            this.lsRegionParentInfo2=1
                                            this.editForm.province02=m.provinceID
                                            this.editForm.city02=m.cityID
                                            this.editForm.county02=m.districtID
                                            this.editForm.town02=m.townshipID
                                            this.editForm.village02=m.villageID
                                        
                                        })
                                    }
                                }
                                if(item.applyUserType==3){
                                    console.log('子女')
                                    // if(item.isAdoption==1){
                                    //     item.isAdoption="是"
                                    // }
                                    let arr1=[]

                                    if(item.isAdoption==1){
                                        arr1.push(item.isAdoption)
                                    }
                                    console.log(99999,arr1)
                                    if(arr1.length>=1){
                                        this.isWhethertoadopt=true
                                    }else{
                                        this.isWhethertoadopt=false
                                    }
                                    item.Adoption="是"
                                    // 是否本地 享受地分析
                                    let isprovincedisabled=false
                                    // if(item.isLocalChild==1){
                                    //     isprovincedisabled=true
                                    // }
                                    if(item.adopteeStatus==0){
                                        item.adopteeStatus=''
                                    }
                                    let provinceID=''
                                    let cityID=''
                                    let districtID=''
                                    let townshipID=''
                                    let villageID=''
                                    item.lsRegionParentInfo1.forEach(m=>{
                                        provinceID=m.provinceID
                                        cityID=m.cityID
                                        districtID=m.districtID
                                        townshipID=m.townshipID
                                        villageID=m.villageID
                                        this.getRegionList(2,2,m.provinceID)
                                        this.getRegionList(3,3,m.cityID)
                                        this.getRegionList(4,4,m.districtID)
                                        this.getRegionList(5,5,m.townshipID)
                                    })
                                 
                                    // console.log(6666,provinceID,cityID,townshipID)
                                    let obj={
                                        ApplicationRecordID03:item.applyUserID,
                                        zp1:item.realName,
                                        zp2:item.sexID,
                                        zp3:item.userBirthday,
                                        zp4:item.certificateNo,
                                        zp5:item.relationshipFather,
                                        zp6:item.relationshipMother,
                                        zp7:item.physicalConditions,
                                        zp8:item.disabilityCertificateNum,
                                        zp9:item.disabilityType,
                                        zp10:item.disabilityLevel,
                                        zp11: item.disabilityTime,
                                        zp12:item.deathConfirmationUnit,
                                        zp13:item.deathTime,
                                        zp14:item.Adoption,
                                        zp16:item.adopteeStatus,
                                        zp15: item.adoptionTime,
                                        provincelist:[],
                                        citylist:[],
                                        countylist:[],
                                        townlist:[],
                                        villagelist:[],
                                        province:provinceID,
                                        city:cityID,
                                        county:districtID,
                                        town:townshipID,
                                        village:villageID,
                                        locality:item.isLocalChild,
                                        isprovincedisabled:isprovincedisabled,
                                        // zp18:publicFun.timestampToTime(item.deathTime).substring(0,10),
                                    }
                                    this.editForm.childrenlist.push(obj)
                                    console.log(22225555,this.editForm.childrenlist)
                                    
                                    this.editForm.childrenlist.forEach((m,n)=>{
                                        console.log(2222,m.province)
                                        // this.childindex++
                                        this.getchildRegionList(n,1,0)
                                        this.getchildRegionList(n,2,m.province)
                                        this.getchildRegionList(n,3,m.city)
                                        this.getchildRegionList(n,4,m.county)
                                        this.getchildRegionList(n,5,m.town)
                                    })
                                }
                                console.log(147258,this.editForm.childrenlist)
                            })


                                // 图集
                                this.editForm.imgp31 = [];
                                this.editForm.imgp32 = [];
                                this.editForm.imgp33 = [];
                                this.editForm.imgp34 = [];
                                this.editForm.imgp35 = [];
                                this.editForm.imgp36 = [];
                                this.editForm.imgp37 = [];
                                this.editForm.imgp38 = [];
                                this.editForm.imgp39 = [];
                                this.editForm.imgp40 = [];
                                response.data.result.lsGallery02.forEach(e=>{
                                    if(e.galleryType==1){
                                        if(e.galleryUrl){
                                            this.editForm.imgp31.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p31=e.galleryUrl
                                            this.editForm.p31img=true
                                        }else{
                                            this.editForm.p31img=false
                                        }
                                    }
                                    if(e.galleryType==2){
                                        if(e.galleryUrl){
                                            this.editForm.imgp32.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p32=e.galleryUrl
                                            this.editForm.p32img=true
                                        }else{
                                            this.editForm.p32img=false
                                        }
                                    }
                                    if(e.galleryType==3){
                                        if(e.galleryUrl){
                                            this.editForm.imgp33.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p33=e.galleryUrl
                                            this.editForm.p33img=true
                                        }else{
                                            this.editForm.p33img=false
                                        }
                                    }
                                    if(e.galleryType==4){
                                        if(e.galleryUrl){
                                            this.editForm.imgp34.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p34=e.galleryUrl
                                            this.editForm.p34img=true
                                        }else{
                                            this.editForm.p34img=false
                                        }
                                    }
                                    if(e.galleryType==5){
                                        if(e.galleryUrl){
                                            this.editForm.imgp35.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p35=e.galleryUrl
                                            this.editForm.p35img=true
                                        }else{
                                            this.editForm.p35img=false
                                        }
                                    }
                                    if(e.galleryType==6){
                                        if(e.galleryUrl){
                                            this.editForm.imgp36.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p36=e.galleryUrl
                                            this.editForm.p36img=true
                                        }else{
                                            this.editForm.p36img=false
                                        }
                                    }
                                    if(e.galleryType==7){
                                        if(e.galleryUrl){
                                            this.editForm.imgp39.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p39=e.galleryUrl
                                            this.editForm.p39img=true
                                        }else{
                                            this.editForm.p39img=false
                                        }
                                    }
                                    if(e.galleryType==8){
                                        if(e.galleryUrl){
                                            this.editForm.imgp37.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p37=e.galleryUrl
                                            this.editForm.p37img=true
                                        }else{
                                            this.editForm.p37img=false
                                        }
                                    }
                                    if(e.galleryType==9){
                                        if(e.galleryUrl){
                                            this.editForm.imgp38.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p38img=true
                                        }else{
                                            this.editForm.p38img=false
                                        }
                                    }
                                    if(e.galleryType==10){
                                        if(e.galleryUrl){
                                            this.editForm.imgp40.push({
                                                url:e.galleryUrl
                                            })
                                            this.editForm.p40=e.galleryUrl
                                            this.editForm.p40img=true
                                        }else{
                                            this.editForm.p40img=false
                                        }
                                    }
                                    
                                })
                                
                                let arr2=[]
                                this.editForm.childrenlist.forEach(e=>{
                                    if(e.zp7==2){
                                        arr2.push(e.zp7)
                                    }
                                })
                                if(arr2.length>=1){
                                    this.isdisability=true
                                }else{
                                    this.isdisability=false
                                }
                                this.isonsubmit=true
                            }
                        break;
                    case 100002:
                        this.$message.error(baseconfig.no_permission_message);
                        break;
                    default:
                        this.$message.error(response.data.message);
                        break;
                    }
                })
                .catch((error) => {});
        },


        // 子女的户籍地
        childrenchange(num,parentID,index){
            this.childindex=index
            switch (num) {
                case 2:
                    console.log("11111")
                    this.editForm.childrenlist[index].citylist=[]; 
                    this.editForm.childrenlist[index].city=''
                    this.editForm.childrenlist[index].countylist = [];
                    this.editForm.childrenlist[index].county = ""
                    this.editForm.childrenlist[index].townlist=[]; 
                    this.editForm.childrenlist[index].town = ""
                    this.editForm.childrenlist[index].villagelist=[]; 
                    this.editForm.childrenlist[index].village = ""
                    this.getchildRegionList(index,2,parentID)
                    break;
                case 3:
                    console.log("11111")
                    this.editForm.childrenlist[index].countylist = [];
                    this.editForm.childrenlist[index].county = ""
                    this.editForm.childrenlist[index].townlist=[]; 
                    this.editForm.childrenlist[index].town = ""
                    this.editForm.childrenlist[index].villagelist=[]; 
                    this.editForm.childrenlist[index].village = ""
                    this.getchildRegionList(index,3,parentID)
                    break;
                case 4:
                    console.log("11111")
                    this.editForm.childrenlist[index].townlist=[]; 
                    this.editForm.childrenlist[index].town = ""
                    this.editForm.childrenlist[index].villagelist=[]; 
                    this.editForm.childrenlist[index].village = ""
                    this.getchildRegionList(index,4,parentID)
                    break;
                case 5:
                    console.log("11111")
                    this.editForm.childrenlist[index].villagelist=[]; 
                    this.editForm.childrenlist[index].village = ""
                    this.getchildRegionList(index,5,parentID)
                    break;
                default:
                    break;
            }
                    
        },
        //获取城市列表
        async getchildRegionList(index,region_level,p_region_id) {
                await regionModule
                    .regioninfogetlist(region_level,p_region_id)
                    .then((response) => {
                    switch (response.data.code) {
                        case 100:{
                            if(region_level==1){
                                this.addchildRegionList=response.data.result
                                this.editForm.childrenlist[index].provincelist=response.data.result
                            }else if(region_level==2){
                                this.editForm.childrenlist[index].citylist=response.data.result
                            }else if(region_level==3){
                                this.editForm.childrenlist[index].countylist=response.data.result
                            }else if(region_level==4){
                                this.editForm.childrenlist[index].townlist=response.data.result
                            }else if(region_level==5){
                                this.editForm.childrenlist[index].villagelist=response.data.result
                            }
                           
                        }  
                        break;
                        case 101:
                        break;
                        case 100002:
                        this.$message.error(baseconfig.no_permission_message);
                        break;
                        default:
                        this.$message.error(response.data.message);
                        break;  
                    }
                    })
                    .catch((error) => {
                    console.log("error", error);
                    this.loading = false;
                });
        }, 
        // 判断是否本地
        comparisonchange(villageid){
            console.log(666666,villageid)
            this.editForm.childrenlist.forEach((item,i)=>{
                console.log(7777,item,item.village)
                if(villageid==item.village){
                    item.locality=1
                }else{
                    item.locality=0
                }
            })
        },
        childrencomparisonchange(villageid,k){
            if(villageid==this.editForm.village01){
                this.editForm.childrenlist[k].locality=1
            }else{
                this.editForm.childrenlist[k].locality=0
            }
        },
        policychange(){
             if(this.editForm.village01!==''){
               this.editForm.childrenlist.forEach((item,i)=>{
                   if(item.village!==''){
                        if(item.village==this.editForm.village01){
                            item.locality=1
                        }else{
                            item.locality=0
                        }
                   }

                })
             }
        
        },
         // 根据身份证获取出生日期和性别
        // 根据身份证获取出生日期
       GetBirthday(psidno){
            var birthdayno,birthdaytemp
            if(psidno.length==18){
                birthdayno=psidno.substring(6,14)
            }else if(psidno.length==15){
                birthdaytemp=psidno.substring(6,12)
                birthdayno="19"+birthdaytemp
            }else{
                return "";
            }
            var birthday=birthdayno.substring(0,4)+"-"+birthdayno.substring(4,6)+"-"+birthdayno.substring(6,8)+" "+"00:00:00"
            let d = new Date(birthday)
            var timestamp =d.getTime();
            // this.timestamp=new Date(birthday.getTime());
            return timestamp
        },
        // 根据输入的身份证获取性别代码
        Getsex(psidno){
            var sexno,sex
            if(psidno.length==18){
                sexno=psidno.substring(16,17)
            }else if(psidno.length==15){
                sexno=psidno.substring(14,15)
            }else{
                return "";
            }
            var tempid=sexno%2;
            if(tempid==0){
                sex=2
            }else{
                sex=1
            }
            return sex
        }
       
    }
}
</script>
<style scoped>
.unitytop_list{
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px; 
}
.unity >>>.el-form-item{
    min-width: 33%;
}
.labeltext{
    width: 320px;
    font-size: 14px;
}
.unity>>>.el-input ,.unity>>>.el-select{
       width: 100% !important;
}
.unity>>>.el-dialog__footer{
    /* width: 76%; */
    margin-left: 25px;
    padding: 20px 0px;
    text-align: center;
}
.unitytop>>>.el-input{
    width: 95% !important;
}
.unitytop_header{
    height: 40px;
    line-height: 40px;
    background: rgb(64, 158, 255,0.3);;
    display: flex;
    align-items: center;
    border-bottom:1px solid rgb(64, 158, 255);
}
.unitytop_header_color{
    width:5px;
    height: 40px;
    background: rgb(64, 158, 255);
    margin-right: 20px;
}
.unitytoplist{
    width: 80%;
    justify-content: inherit;
}
.info_top{
      display: flex;
      margin-top: 20px;
      width: 76%;
}
@media only screen and (max-width:1400px) {
     .unityimg_list >>>.el-form-item {
        min-width: 30%;
        width: 18% !important;
   }
    .childrenlist-left{
        width:80% !important;
    }
   .unity>>> .el-form-item {
        min-width: 48% ;
        width: 48%;
    }
    .childrenlist-left >>>.el-form-item {
        min-width: 48% !important;
        width: 48%;
   }
}
@media only screen and (max-width:1480px) {
    .unityimg_list{
        width: 90% !important;
    }
    .unityimg_list >>>.el-form-item {
     min-width: 30%;
     width: 30% ;
   }
}
@media only screen and (max-width:1200px) {
    .childrenlist-left{
        width:80% !important;
    }
    .childrenlist-left >>>.el-form-item {
     min-width: 48% !important;
     width: 48%;
   }
    .unityimg_list{
        width: 90% !important;
    }
    .unityimg_list >>>.el-form-item {
        min-width: 30%;
        width: 30% ;
    }
}
.childrenlist-left >>>.el-form-item__label{
    width: 125px !important;
}
.childrenlist-left >>>.el-form-item__content{
    margin-left: 125px !important;
}
.unitytop{
    min-width: 900px;
}
.unityimg_list >>>.el-form-item {
     min-width: 30%;
}
.unityimg_list{
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px; 
    padding-left: 30px;
}

.unityimg_list_item >>>.el-form-item__content{
    display: flex;
}
.unityimg_list >>>.el-form-item__content >div+div{
    margin-left:20px;
}
.uploadImgtext{
    display: flex;
    align-items: center;
    justify-content: center;
}

/*  */
.childrenlist{
    display: flex;
    background: #fafafa;;
    margin: 15px auto;
}
.childrenlist-left{
    width: 90%;
    
    padding: 10px 0px ;
   box-sizing:border-box ;
}
.childrenlist-left>div{
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.childrenlist-left>>>.el-form-item__label{
    /* color: #fff; */
}
.childrenlist-left>div>div{
    min-width:30% !important;
}
.childrenlist-right{
    width: 10%;
    display: flex;
    margin-top: 10px;
}
.childrennum{
    width: 95%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 auto;

}
.childrennum>div{
    min-width: 33%;
}
.childrennum>>> .el-form-item__label{
    width:235px !important;
}
.childrennum>>> .el-form-item__content{
    margin-left: 235px  !important;
}
.regionlist{
    width: 98% !important;
}
.regionlist-item{
    width: 19%;
}
.regionlist>>>.el-form-item__content{
    display: flex;
    align-items: center;
    margin-left: 0 !important;
}

.unityimg_list>>>.el-upload--picture-card {
    width: 120px !important;
    height: 120px !important;
    line-height: 120px !important;
}
.unityimg_list>>>.el-upload-list--picture-card .el-upload-list__item{
    width: 120px !important;
    height: 120px !important;
    /* line-height: 120px !important; */
}
.unityimg_list>>>.el-upload-list li{
    margin-right: 10px !important;
}
.disUoloadSty>>>div{
     width: 120px !important;
    height: 120px !important;
}
.unityimglistitem{
    min-width: 40% !important
}
.localitylist{
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.localitylist>div{
    min-width: 30% !important;
}
.islocality{
    display: none;
}

</style>
<style>
.disUoloadSty .el-upload--picture-card{
  display:none;   /* 上传按钮隐藏 */
}
</style>